import React, { useCallback, useEffect, useRef, useState } from "react";
import { AmountDivideByHundred } from "../../../helper";
import { eventsPageSplitUpApi, expireHoldToken } from "../../../api";
import moment from "moment-timezone";
import SimpleReactValidator from "simple-react-validator";
import { isValidPhoneNumber } from "libphonenumber-js";
import brand from "../../../assets/imgs/brand.svg";
import outOfStock from "../../../assets/imgs/outOfStock.png";
import backArrow from "../../../assets/imgs/backArrowBlack.svg";
import { SpError } from "../../../widgetDesign";
import { COUNTRY_PHONE_CODE, COUNTRIES_LIST } from "../../../appconstants";
import Select from "react-select";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const ProductReview = (props) => {
    const {
        eventDetails,
        orderItems,
        setPayload,
        setPayNow,
        payNow,
        setErrorMessage,
        setOrderItems,
        mobileView,
        getOperatingTime,
        handleBack,
        hideHeader,
        selectedDate: propSelectedDate,
        setSelectedDate: propSetSelectedDate,
    } = props;
    const eventGids = [
        'eventpage-dd960edf106c4ebeb1ec4d2ce5312984',
        'eventpage-be229226664b471fae09015745f633f0',
    ];

    const [customInfoValues, setCustomInfoValues] = useState(() => {
        if (!eventDetails?.eventPageCustomInfos || eventDetails?.eventPageCustomInfos?.length === 0) {
            return [];
        }
        const existing = eventDetails?.eventPageCustomInfos?.map((customInfo) => {
            let label = customInfo.inputFieldLabel;
            if (label.toLowerCase() === "email") label = "Email Address";
            if (label.toLowerCase() === "phone") label = "Phone Number";
            return {
                ...customInfo,
                inputFieldLabel: label,
                value: customInfo.value || "",
            };
        }) || [];

        const defaultFields = []
        //  [
        //     { inputFieldLabel: "Full Name", inputFieldType: "INPUT_TEXT", isOptional: false, value: "" },
        //     { inputFieldLabel: "Email Address", inputFieldType: "INPUT_EMAIL", isOptional: false, value: "" },
        //     { inputFieldLabel: "Phone Number", inputFieldType: "INPUT_TEXT", isOptional: false, value: "" },
        // ];

        const missingFields = defaultFields.filter((df) => {
            const dfLabel = df.inputFieldLabel.toLowerCase();
            return !existing.some((e) => {
                const eLabel = e.inputFieldLabel.toLowerCase();
                const normalizedELabel = eLabel.replace(" address", "").replace(" number", "");
                const normalizedDfLabel = dfLabel.replace(" address", "").replace(" number", "");
                return eLabel.includes(normalizedDfLabel) || dfLabel.includes(normalizedELabel);
            });
        });

        return [...missingFields, ...existing];
    });

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const bannerImages = eventDetails?.bannerImages && eventDetails?.bannerImages.length 
        ? eventDetails?.bannerImages 
        : (eventDetails?.banner ? [eventDetails.banner] : []);

    const nextImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prev) => (prev + 1) % bannerImages.length);
    };

    const prevImage = (e) => {
        e.stopPropagation();
        setCurrentImageIndex((prev) => (prev - 1 + bannerImages.length) % bannerImages.length);
    };

    const openImageModal = (imageSrc) => {
        setModalImageSrc(imageSrc);
        setIsImageModalOpen(true);
    };

    const closeImageModal = () => {
        setIsImageModalOpen(false);
        setModalImageSrc('');
    };

    const hasCustomProducts = eventDetails?.eventPageProducts?.some(p => p.eventPageProductType !== 'TICKET');
    const showBannerImage = eventDetails?.isSeatedEvent && !hasCustomProducts && !mobileView;

    const [promoCode, setPromoCode] = useState("");
    const [promoCodeValue, setPromoCodeValue] = useState("");
    const [message, setMessage] = useState("");
    const [subtotal, setSubtotal] = useState(0.0);
    const [orderDiscount, setOrderDiscount] = useState(0.0);
    const [serviceCharge, setServiceCharge] = useState(0.0);
    const [serviceFeePercentage, setServiceFeePercentage] = useState(0.0);
    const [taxes, setTaxes] = useState(0.0);
    const [tipAmount, setTipAmount] = useState(0.0);
    const [total, setTotal] = useState(0.0);
    const [rawTotal, setRawTotal] = useState(0);
    const [tip, setTip] = useState(null);
    const [tipInputValue, setTipInputValue] = useState("");
    const [tipType, setTipType] = useState("AMOUNT");
    const [customTip, setCustomTip] = useState(false);
    const [activeModifier, setActiveModifier] = useState(null);
    const [activeItem, setActiveItem] = useState(null);
    const [activeItemModifier, setActiveItemModifier] = useState(null);
    const [validationErrors, setValidationErrors] = useState([]);
    const [mandatoryItems, setMandatoryItems] = useState([]);
    const [updateOrderItem, setUpdateOrderItem] = useState(false);
    const [activeTab, setActiveTab] = useState(null);
    const [sortedProducts, setSortedProducts] = useState([]);
    const [isCalculating, setIsCalculating] = useState(false);
    const [lastCalculatedItems, setLastCalculatedItems] = useState("");
    const lastPayloadRef = useRef(null);
    const [countryCode, setCountryCode] = useState(() => {
        if (eventDetails?.currency === "INR") return "+91";
        return "+1";
    });
    const [localSelectedDate, setLocalSelectedDate] = useState(() => {
        const firstAvailableDate = eventDetails?.eventPageDateTimes?.find(dt => !dt.disabled) 
            || eventDetails?.eventPageDateTimes?.[0];
        
        return firstAvailableDate
            ? firstAvailableDate
            : eventDetails?.eventDate
                ? {
                    eventDate: eventDetails.eventDate,
                    eventStartTime: eventDetails.eventStartTime,
                    eventEndTime: eventDetails.eventEndTime,
                }
                : null;
    });

    const selectedDate = propSelectedDate || localSelectedDate;
    const setSelectedDate = propSetSelectedDate || setLocalSelectedDate;

    const scrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const checkScroll = useCallback(() => {
        if (scrollRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
            setCanScrollLeft(scrollLeft > 5);
            setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
        }
    }, []);

    useEffect(() => {
        const el = scrollRef.current;
        if (el) {
            checkScroll();
            el.addEventListener("scroll", checkScroll);
            window.addEventListener("resize", checkScroll);
            
            const timer = setTimeout(checkScroll, 500);
            
            return () => {
                el.removeEventListener("scroll", checkScroll);
                window.removeEventListener("resize", checkScroll);
                clearTimeout(timer);
            };
        }
    }, [eventDetails?.eventPageDateTimes, checkScroll]);

    const scrollLeftFn = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };

    const scrollRightFn = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    const getEventTimeRange = (dateOption) => {
        if (!dateOption || dateOption.eventStartTime === undefined || dateOption.eventStartTime === null) return "";
        const startTime = getOperatingTime(dateOption.eventStartTime);
        if (dateOption.eventEndTime === undefined || dateOption.eventEndTime === null || dateOption.eventEndTime === dateOption.eventStartTime) {
            return startTime;
        }
        return `${startTime} - ${getOperatingTime(dateOption.eventEndTime)}`;
    };

    useEffect(() => {
        if (eventDetails?.eventPageProducts) {
            let filteredProducts = eventDetails.eventPageProducts;
            if (eventDetails.isSeatedEvent) {
                // For seated events, we don't render ticket details in the review page 
                // but they still show up in the bill summary
                filteredProducts = filteredProducts.filter(p => p.eventPageProductType !== "TICKET");
            }
            const sorted = [...filteredProducts].sort((a, b) => {
                const order = { TICKET: 1, FOOD: 2, CUSTOM: 3 };
                return (order[a.eventPageProductType] || 99) - (order[b.eventPageProductType] || 99);
            });
            setSortedProducts(sorted);
        }
    }, [eventDetails]);

    useEffect(() => {
        if (sortedProducts.length > 0 && !activeTab) {
            setActiveTab(sortedProducts[0].gid);
        }
    }, [sortedProducts, activeTab]);

    useEffect(() => {
        if (!mobileView) {
            setTimeout(() => {
                const sidebar = document.querySelector(".figma-sidebar-summary");
                if (sidebar) {
                    sidebar.scrollTo({
                        top: sidebar.scrollHeight,
                        behavior: "smooth"
                    });
                }
            }, 300);
        }
    }, [mobileView]);

    const toggleModifier = (gid) => setActiveModifier(activeModifier === gid ? null : gid);
    const toggleItem = (gid) => setActiveItem(activeItem === gid ? null : gid);
    const toggleItemModifier = (gid) => setActiveItemModifier(activeItemModifier === gid ? null : gid);

    const updates = orderItems.flatMap((item) => item.lineItems);

    const updateQuantity = (customItem, item, modifier, subModifier, change, value, duplicateIndex, productGidArg) => {
        setOrderItems((prevOrderItems) => {
            const nextOrderItems = JSON.parse(JSON.stringify(prevOrderItems));
            const productGid =
                productGidArg ||
                item?.productGid ||
                customItem?.productGid ||
                (item
                    ? eventDetails.eventPageProducts.find(
                        (p) =>
                            p.items?.some((i) => i.gid === item.gid) ||
                            p.customItems?.some((ci) => ci.items?.some((i) => i.gid === item.gid))
                    )?.gid
                    : eventDetails.eventPageProducts.find((p) =>
                        p.customItems?.some((ci) => ci.gid === customItem.gid)
                    )?.gid);

            let orderItem = nextOrderItems.find((oi) => oi.productGid === productGid);
            if (!orderItem) {
                const product = eventDetails.eventPageProducts.find((p) => p.gid === productGid);
                orderItem = {
                    productGid,
                    name: product?.eventPageProductName,
                    title:
                        product?.eventPageProductType === "TICKET"
                            ? "Ticket"
                            : product?.eventPageProductType === "FOOD"
                                ? "Food"
                                : product?.eventPageProductName,
                    lineItems: [],
                    totalAmount: 0,
                    totalCount: 0,
                };
                nextOrderItems.push(orderItem);
            }

            let lineItem;
            if (duplicateIndex !== undefined && duplicateIndex !== null) {
                lineItem = orderItem.lineItems.find(
                    (li) =>
                        (item && !customItem ? li.itemGid === item.gid : li.customItemGid === customItem.gid) &&
                        li.duplicateIndex === duplicateIndex
                );
            } else {
                lineItem = orderItem.lineItems.find(
                    (li) =>
                        (item && !customItem ? li.itemGid === item.gid : li.customItemGid === customItem.gid) &&
                        li.listedItem
                );
            }

            if (customItem && item) {
                if (!lineItem) return nextOrderItems;
                let lineItemItem = lineItem.lineItemItems?.find((lii) => lii.itemGid === item.gid);
                if (modifier) {
                    if (!lineItemItem) return nextOrderItems;
                    const existingModifier = lineItemItem.lineItemModifiers?.find(
                        (m) => m.modifierGid === modifier.gid
                    );
                    if (existingModifier) {
                        existingModifier.quantity += change;
                        if (existingModifier.quantity <= 0) {
                            lineItemItem.lineItemModifiers = lineItemItem.lineItemModifiers.filter(
                                (m) => m.modifierGid !== modifier.gid
                            );
                        }
                    } else if (change > 0) {
                        lineItemItem.lineItemModifiers = [
                            ...(lineItemItem.lineItemModifiers || []),
                            {
                                modifierGid: modifier.gid,
                                name: modifier.name,
                                price: modifier.price,
                                quantity: change,
                            },
                        ];
                    }
                } else {
                    if (!lineItemItem && change > 0) {
                        lineItemItem = {
                            itemGid: item.gid,
                            name: item.displayName || item.name,
                            price: item.price || 0,
                            quantity: change,
                            lineItemModifiers: [],
                            lineItemDiscounts: item.coupon ? [{
                                couponGid: item.coupon.gid,
                                name: item.coupon.name || "Item Discount",
                                amountOff: item.coupon.amountOff || 0,
                                percentageOff: item.coupon.percentageOff || 0,
                            }] : [],
                        };
                        lineItem.lineItemItems = [...(lineItem.lineItemItems || []), lineItemItem];
                    } else if (lineItemItem) {
                        lineItemItem.quantity += change;
                        if (lineItemItem.quantity <= 0) {
                            lineItem.lineItemItems = lineItem.lineItemItems.filter(
                                (lii) => lii.itemGid !== item.gid
                            );
                        }
                    }
                }
            } else {
                if (!lineItem && change > 0) {
                    let initialQty = change;
                    if (customItem) {
                        const available = customItem.enableStock
                            ? Math.min(customItem.stockQuantity ?? Infinity, customItem.onlineStock ?? Infinity)
                            : Infinity;
                        initialQty = customItem.minQuantity ? Math.min(customItem.minQuantity, available) : change;
                    }

                    lineItem = {
                        productGid: productGid,
                        itemGid: item?.gid,
                        customItemGid: customItem?.gid,
                        name:
                            item?.displayName ||
                            customItem?.inputFieldLabel ||
                            customItem?.eventPageProductName,
                        price: item?.price || customItem?.amount || customItem?.price || 0,
                        quantity: initialQty,
                        totalPrice: (item?.price || customItem?.amount || customItem?.price || 0) * initialQty,
                        lineItemModifiers: [],
                        lineItemItems: [],
                        lineItemDiscounts: item?.coupon ? [{
                            couponGid: item.coupon.gid,
                            name: item.coupon.name || "Item Discount",
                            amountOff: item.coupon.amountOff || 0,
                            percentageOff: item.coupon.percentageOff || 0,
                        }] : [],
                        listedItem: duplicateIndex === undefined || duplicateIndex === null,
                        duplicateIndex: duplicateIndex,
                    };
                    orderItem.lineItems.push(lineItem);
                } else if (lineItem) {
                    if (modifier) {
                        const existingModifier = lineItem.lineItemModifiers?.find(
                            (m) => m.modifierGid === modifier.gid
                        );
                        if (existingModifier) {
                            existingModifier.quantity += change;
                            if (existingModifier.quantity <= 0) {
                                lineItem.lineItemModifiers = lineItem.lineItemModifiers.filter(
                                    (m) => m.modifierGid !== modifier.gid
                                );
                            }
                        } else if (change > 0) {
                            lineItem.lineItemModifiers = [
                                ...(lineItem.lineItemModifiers || []),
                                {
                                    modifierGid: modifier.gid,
                                    name: modifier.name,
                                    price: modifier.price,
                                    quantity: change,
                                },
                            ];
                        }
                    } else {
                        if (customItem) {
                            const available = customItem.enableStock
                                ? Math.min(customItem.stockQuantity ?? Infinity, customItem.onlineStock ?? Infinity)
                                : Infinity;

                            if (change > 0) {
                                const nextQty = lineItem.quantity + change;
                                if (customItem.maxQuantity && nextQty > customItem.maxQuantity) {
                                    // at max
                                } else if (nextQty > available) {
                                    // at stock max
                                } else {
                                    lineItem.quantity = nextQty;
                                }
                            } else {
                                const nextQty = lineItem.quantity + change;
                                if (customItem.minQuantity && lineItem.quantity <= customItem.minQuantity) {
                                    lineItem.quantity = 0;
                                } else if (nextQty <= 0) {
                                    lineItem.quantity = 0;
                                } else {
                                    lineItem.quantity = nextQty;
                                }
                            }
                        } else {
                            lineItem.quantity += change;
                        }

                        if (lineItem.quantity <= 0) {
                            orderItem.lineItems = orderItem.lineItems.filter((li) => li !== lineItem);
                        }
                    }
                }
            }

            if (lineItem) {
                const originalProduct = eventDetails.eventPageProducts?.find((p) => p.gid === productGid);
                let originalBasePrice = 0;
                if (lineItem.customItemGid) {
                    const originalCustomItem = originalProduct?.customItems?.find(
                        (ci) => ci.gid === lineItem.customItemGid
                    );
                    originalBasePrice = originalCustomItem?.amount || originalCustomItem?.price || 0;
                } else {
                    const itemInProduct = originalProduct?.items?.find((i) => i.gid === lineItem.itemGid);
                    const itemInCustom = !itemInProduct ? originalProduct?.customItems?.flatMap(ci => ci.items || []).find(i => i.gid === lineItem.itemGid) : null;
                    originalBasePrice = itemInProduct?.price || itemInCustom?.price || 0;
                }

                const modifiersTotal = (lineItem.lineItemModifiers || []).reduce(
                    (sum, m) => sum + m.price * m.quantity,
                    0
                );
                const itemsTotal = (lineItem.lineItemItems || []).reduce((sum, lii) => {
                    const liiModifiersTotal = (lii.lineItemModifiers || []).reduce(
                        (s, m) => s + m.price * m.quantity,
                        0
                    );
                    return sum + (lii.price + liiModifiersTotal) * lii.quantity;
                }, 0);

                const unitPrice = originalBasePrice;
                lineItem.price = unitPrice;
                lineItem.totalPrice = (unitPrice + (modifiersTotal / 1) + (itemsTotal / 1)) * lineItem.quantity;
            }

            orderItem.totalAmount = orderItem.lineItems.reduce(
                (sum, li) => sum + (li.totalPrice || 0),
                0
            );
            orderItem.totalCount = orderItem.lineItems.reduce(
                (sum, li) => sum + (li.quantity || 0),
                0
            );

            return nextOrderItems;
        });
    };

    const duplicateItem = (customItem, item) => {
        let validationError;
        if (customItem) {
            validationError = validationErrors.filter((error) => error.customItemGid === customItem.gid);
        } else {
            validationError = validationErrors.filter((error) => error.itemGid === item.gid);
        }
        if (validationError?.length > 0) {
            validationError.forEach((error) => setErrorMessage(error.errorMessage));
            return;
        }

        const normalize = (value) => (value ? value : []);

        setOrderItems((prevOrderItems) => {
            const nextOrderItems = JSON.parse(JSON.stringify(prevOrderItems));
            const productGid =
                item?.productGid ||
                customItem?.productGid ||
                (item
                    ? eventDetails.eventPageProducts.find(
                        (p) =>
                            p.items?.some((i) => i.gid === item.gid) ||
                            p.customItems?.some((ci) => ci.items?.some((i) => i.gid === item.gid))
                    )?.gid
                    : eventDetails.eventPageProducts.find((p) =>
                        p.customItems?.some((ci) => ci.gid === customItem.gid)
                    )?.gid);

            let orderItem = nextOrderItems.find((oi) => oi.productGid === productGid);
            if (!orderItem) return nextOrderItems;

            let listedLineItemIndex = orderItem.lineItems.findIndex(
                (li) =>
                    (item && !customItem ? li.itemGid === item.gid : li.customItemGid === customItem.gid) &&
                    li.listedItem
            );

            if (listedLineItemIndex !== -1) {
                let listedLineItem = orderItem.lineItems[listedLineItemIndex];
                let updateItem = JSON.parse(JSON.stringify(listedLineItem));

                const matchingItemIndex = orderItem.lineItems.findIndex((lineItem) =>
                    !lineItem.listedItem &&
                    updateItem.customItemGid === lineItem.customItemGid &&
                    updateItem.itemGid === lineItem.itemGid &&
                    JSON.stringify(normalize(lineItem.lineItemModifiers)) === JSON.stringify(normalize(updateItem.lineItemModifiers)) &&
                    JSON.stringify(normalize(lineItem.lineItemItems)) === JSON.stringify(normalize(updateItem.lineItemItems)) &&
                    JSON.stringify(normalize(lineItem.lineItemDiscounts)) === JSON.stringify(normalize(updateItem.lineItemDiscounts))
                );

                if (matchingItemIndex !== -1) {
                    orderItem.lineItems[matchingItemIndex].quantity += updateItem.quantity;
                } else {
                    let size;
                    if (customItem) {
                        size = orderItem.lineItems.filter((update) => update.customItemGid === customItem.gid).length;
                    } else {
                        size = orderItem.lineItems.filter((update) => update.itemGid === item.gid).length;
                    }
                    updateItem.listedItem = false;
                    updateItem.duplicateIndex = size + 1;
                    orderItem.lineItems.push(updateItem);
                }
            }

            orderItem.totalAmount = orderItem.lineItems.reduce(
                (sum, li) => sum + (li.totalPrice || 0),
                0
            );
            orderItem.totalCount = orderItem.lineItems.reduce(
                (sum, li) => sum + (li.quantity || 0),
                0
            );

            return nextOrderItems;
        });
    };

    const simpleValidator = useRef(
        new SimpleReactValidator({
            validators: {
                phoneNumValidation: {
                    message: "The phone number is invalid",
                    rule: (val, param) => isValidPhoneNumber(param[0]),
                },
                checkLowerCase: {
                    message: "Email address must not contain uppercase letters.",
                    rule: (val) => val === val.toLowerCase(),
                },
            },
        })
    );

    const customInfoRef = useRef(customInfoValues);
    useEffect(() => {
        customInfoRef.current = customInfoValues;
    }, [customInfoValues]);

    const calculateOrder = useCallback(
        async (tipValue, tipOption, isCustom, promo) => {
            if (eventDetails) {
                if (payNow) return; // Don't recalculate while payment is in progress
                setIsCalculating(true);
                const currentItemsTag = JSON.stringify(orderItems);
                
                const lineItems = orderItems.flatMap((item) => item.lineItems);

                if (lineItems.length === 0) {
                    setSubtotal(0);
                    setOrderDiscount(0);
                    setServiceCharge(0);
                    setServiceFeePercentage(0);
                    setTaxes(0);
                    setTipAmount(0);
                    setTotal(0);
                    setIsCalculating(false);
                    return;
                }

                console.log('the customer info values are: ', customInfoRef.current);
                let customerPhoneNumber = null;
                const customerPhoneNumberList = Array.isArray(customInfoRef.current)
                    && customInfoRef.current.filter(customerInfo => (
                        customerInfo?.inputFieldType === 'INPUT_PHONE'
                    ));
                console.log(customerPhoneNumberList);
                if (Array.isArray(customerPhoneNumberList)
                    && customerPhoneNumberList.length > 0
                    && countryCode
                ) {
                    const phoneVal = customerPhoneNumberList[0].value;
                    if (phoneVal && !phoneVal.startsWith("+")) {
                        customerPhoneNumber = `${countryCode}${phoneVal}`;
                    } else {
                        customerPhoneNumber = phoneVal;
                    }
                }
                const payload = {
                    phoneNumber: customerPhoneNumber,
                    eventPageGid: eventDetails.gid,
                    promoCode: promo ? promo : null,
                    tip: tipValue
                        ? isCustom
                            ? typeof tipValue === 'string'
                                ? Math.round(Number(tipValue.replace(/,/g, "")) * 100)
                                : tipValue
                            : tipValue
                        : null,
                    tipType: tipOption,
                    eventPageDateTimeGid: selectedDate?.gid,
                    eventPageOrderLineItems: lineItems.map(item => ({
                        ...item,
                        seats: item.seats || (item.seatLabel ? [item.seatLabel] : []),
                        lineItemItems: item.eventPageTicketTypeGid ? [{
                            quantity: 1,
                            ticketTypeGid: item.eventPageTicketTypeGid
                        }] : (item.lineItemItems?.map(({ amount, ...lii }) => lii) || [])
                    })),
                    eventPageOrderDiscounts: eventDetails.coupon
                        ? [
                            {
                                discountGid: eventDetails.coupon.gid,
                                stackable: eventDetails.discountStackable,
                                type: "COUPON",
                                amountOff: eventDetails.coupon.amountOff
                                    ? eventDetails.coupon.amountOff * -1
                                    : eventDetails.coupon.amountOff,
                                percentageOff: eventDetails.coupon.percentageOff,
                            },
                        ]
                        : [],
                };

                localStorage.setItem("eventsPayload", JSON.stringify(payload));

                try {
                    const value = await eventsPageSplitUpApi(payload);
                    if (value) {
                        setSubtotal(value.subTotal ? AmountDivideByHundred(value.subTotal) : 0);
                        setOrderDiscount(
                            value.orderDiscount ? AmountDivideByHundred(value.orderDiscount * -1) : 0
                        );
                        setServiceCharge(value.serviceFee ? AmountDivideByHundred(value.serviceFee) : 0);
                        setServiceFeePercentage(
                            value.serviceFeePercentage ? AmountDivideByHundred(value.serviceFeePercentage) : 0
                        );
                        setTaxes(value.tax ? AmountDivideByHundred(value.tax) : 0);
                        setTipAmount(value.tipAmount ? Number(value.tipAmount) : 0);
                        setRawTotal(value.netPayable ? Number(value.netPayable) : 0);
                        setTotal(value.netPayable ? AmountDivideByHundred(value.netPayable) : 0);
                        setMessage(value.message ? value.message : "");
                        setLastCalculatedItems(currentItemsTag);
                    }
                } catch (error) {
                    // status check meant for promo code validity check
                    // in the case promo code only use once per customer
                    // functionality is enabled
                    if (error?.status === 424) {
                        setMessage(error?.data?.message);
                    } else {
                        const errorMsg = error?.response?.data?.message || error?.data?.message || error?.message || "Something went wrong";
                        setErrorMessage(errorMsg);
                    }
                } finally {
                    setIsCalculating(false);
                }
            }
        },
        [eventDetails, orderItems, selectedDate, countryCode]
    );

    useEffect(() => {
        calculateOrder(tip, tipType, customTip, promoCode);
    }, [calculateOrder, tip, tipType, customTip, promoCode, countryCode]);

    const handleCheckout = () => {
        if (isCalculating) return;

        if (total > 0) {
            const formValid = simpleValidator.current.allValid();
            if (!formValid) {
                simpleValidator.current.showMessages();
                const list = [...customInfoValues];
                setCustomInfoValues(list);
                setErrorMessage("Please fill all required fields correctly.");
                return;
            }

            const holdToken = sessionStorage.getItem("seatsio")
                ? JSON.parse(sessionStorage.getItem("seatsio")).holdToken
                : null;

            const normalize = (value) => (value ? value : []);

            const groupedLineItems = [];
            orderItems.flatMap((item) => item.lineItems).forEach((lineItem) => {
                const sanitizedLineItemItems = lineItem.eventPageTicketTypeGid ? [{
                    quantity: 1,
                    ticketTypeGid: lineItem.eventPageTicketTypeGid
                }] : (lineItem.lineItemItems?.map(({ amount, ...lii }) => ({
                    ...lii,
                    lineItemDiscounts: lii.lineItemDiscounts || []
                })) || []);

                const existingIndex = lineItem.seatLabel
                    ? -1
                    : groupedLineItems.findIndex(
                        (existingItem) =>
                            existingItem.customItemGid === lineItem.customItemGid &&
                            existingItem.itemGid === lineItem.itemGid &&
                            existingItem.eventPageTicketTypeGid === lineItem.eventPageTicketTypeGid &&
                            JSON.stringify(normalize(existingItem.lineItemModifiers)) ===
                            JSON.stringify(normalize(lineItem.lineItemModifiers)) &&
                            JSON.stringify(normalize(existingItem.lineItemItems)) ===
                            JSON.stringify(normalize(sanitizedLineItemItems)) &&
                            JSON.stringify(normalize(existingItem.lineItemDiscounts)) ===
                            JSON.stringify(normalize(lineItem.lineItemDiscounts))
                    );

                if (existingIndex !== -1) {
                    groupedLineItems[existingIndex].quantity += lineItem.quantity;
                    groupedLineItems[existingIndex].totalPrice += (lineItem.totalPrice || 0);
                } else {
                    groupedLineItems.push({
                        ...lineItem,
                        seats: lineItem.seats || (lineItem.seatLabel ? [lineItem.seatLabel] : []),
                        lineItemDiscounts: lineItem.lineItemDiscounts || [],
                        lineItemItems: sanitizedLineItemItems
                    });
                }
            });

            const newPayload = {
                eventPageGid: eventDetails.gid,
                promoCode: promoCode && message && message === "Promo-Code applied" ? promoCode : null,
                totalTip: Number(tipAmount),
                total: Number(rawTotal),
                holdToken,
                eventPageOrderLineItems: groupedLineItems,
                eventPageOrderLabels: customInfoValues
                    .filter((customInfo) => customInfo.value)
                    .map((customInfo) => {
                        let value = customInfo.value;
                        if (countryCode && (customInfo.inputFieldLabel === "Phone Number" || customInfo.inputFieldLabel.toLowerCase().includes("phone") || customInfo?.inputFieldType === "INPUT_PHONE")) {
                            if (value && !value.startsWith("+")) {
                                value = `${countryCode}${value}`;
                            }
                        }
                        return { label: customInfo.inputFieldLabel, value: value, dataType: customInfo?.inputFieldType };
                    }),
                eventPageOrderLink: {
                    redirectUri: eventDetails.redirectUrl ? eventDetails.redirectUrl :
                        (process.env.REACT_APP_ENV === "Production"
                            ? "https://dashboard.swirepay.com"
                            : "https://staging.swirepay.com") + "/event-page-receipts",
                },
                eventPageDateTimeGid: selectedDate?.gid,
                orderMode: "ONLINE",
            };

            setPayload(newPayload);
            setPayNow(true);
        } else if (total === 0) {
            setErrorMessage("Total can't be zero...");
        }
    };

    const handleInputChange = (index, newValue) => {
        const updatedCustomInfos = [...customInfoValues];
        updatedCustomInfos[index].value = newValue;
        setCustomInfoValues(updatedCustomInfos);
    };

    const handleApplyPromo = () => {
        setPromoCode(promoCodeValue);
        calculateOrder(tip, tipType, customTip, promoCodeValue);
    };

    return (
        <div className="figma-review-container">
            <div className="figma-main-column">
                {!hideHeader && (
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '12px', 
                        marginBottom: mobileView ? '16px' : '24px',
                        marginTop: mobileView ? '16px' : '0',
                        paddingLeft: mobileView ? '16px' : '0',
                        paddingRight: mobileView ? '16px' : '0'
                    }}>
                        <button
                            onClick={handleBack}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: mobileView ? '32px' : '40px',
                                height: mobileView ? '32px' : '40px',
                                borderRadius: '50%',
                                background: '#fff',
                                border: '1px solid #e2e8f0',
                                cursor: 'pointer',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
                            onMouseOut={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                        >
                            {mobileView ? (
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="19" y1="12" x2="5" y2="12"></line>
                                    <polyline points="12 19 5 12 12 5"></polyline>
                                </svg>
                            ) : (
                                <img src={backArrow} alt="Back" style={{ width: '20px', height: '20px' }} />
                            )}
                        </button>
                        {sortedProducts.length > 0 && (
                            <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#111827", margin: 0, letterSpacing: '-0.02em' }}>
                                Product Details
                            </h1>
                        )}
                    </div>
                )}

                {/* Event Info & Date Selection Card */}
                <div className="figma-selection-card" style={{ background: '#fff', padding: mobileView ? '20px' : '32px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)', marginBottom: '8px' }}>
                    <div style={{ marginBottom: '24px' }}>
                        <h2 className="figma-event-title-address" style={{ fontSize: '20px', fontWeight: '700', color: '#111827', marginBottom: '16px', letterSpacing: '-0.02em' }}>
                            {eventDetails?.title} @ {eventDetails?.address?.street || eventDetails?.eventPageAddress}, {eventDetails?.address?.city}, {eventDetails?.address?.state}, USA, {eventDetails?.address?.postalCode}
                        </h2>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#4b5563', fontSize: '15px', marginBottom: '24px' }}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                                <path d="M5.3335 1.33301V3.99967" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M10.6665 1.33301V3.99967" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M2 6.66699H14" stroke={eventDetails?.primaryColor || '#155DFC'} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            <span style={{ fontWeight: '500', color: '#1f2937' }}>Selected Event Date:</span>
                            <span style={{ color: '#4b5563' }}>
                                {selectedDate?.eventDate
                                    ? `${moment.utc(selectedDate.eventDate).format("MMM DD, YYYY")}, ${getEventTimeRange(selectedDate)}`
                                    : "N/A"}
                            </span>
                        </div>
                    </div>

                    {/* Date Selection Cards */}
                    {!eventDetails.isSeatedEvent && (
                        <div style={{ position: 'relative', width: '100%', overflow: 'visible' }}>
                            {/* Left Scroll Indicator & Button (Mobile View only) */}
                            {mobileView && eventDetails?.eventPageDateTimes?.length > 1 && canScrollLeft && (
                                <>
                                    <div style={{
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: '40px',
                                        background: 'linear-gradient(to right, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0))',
                                        pointerEvents: 'none',
                                        zIndex: 5
                                    }} />
                                    <button
                                        onClick={scrollLeftFn}
                                        style={{
                                            position: 'absolute',
                                            left: '4px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            zIndex: 10,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            background: '#ffffff',
                                            border: '1px solid #e2e8f0',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                                            cursor: 'pointer',
                                            color: eventDetails?.primaryColor || '#2563eb',
                                            padding: 0
                                        }}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="15 18 9 12 15 6"></polyline>
                                        </svg>
                                    </button>
                                </>
                            )}

                            <div
                                ref={scrollRef}
                                className="figma-dates-horizontal-scroll"
                                style={{ display: 'flex', gap: '16px', overflowX: 'auto', paddingBottom: '8px' }}
                            >
                                {eventDetails?.eventPageDateTimes?.map((dateOption, index) => (
                                    <div
                                        key={index}
                                        className={`figma-date-card-modern ${selectedDate?.gid === dateOption.gid ? "selected" : ""} ${dateOption.disabled ? "disabled" : ""}`}
                                        style={{
                                            ...(selectedDate?.gid === dateOption.gid ? {
                                                borderColor: eventDetails?.primaryColor || '#2563eb',
                                                background: `${eventDetails?.primaryColor || '#2563eb'}0a`
                                            } : {}),
                                            ...(dateOption.disabled ? {
                                                opacity: 0.6,
                                                filter: 'grayscale(1)',
                                                cursor: 'not-allowed',
                                                pointerEvents: 'none'
                                            } : {})
                                        }}
                                        onClick={() => {
                                            if (!dateOption.disabled && selectedDate?.gid !== dateOption.gid) {
                                                const seats = sessionStorage.getItem('seatsio') ? JSON.parse(sessionStorage.getItem('seatsio')) : undefined;
                                                if (seats?.holdToken) {
                                                    expireHoldToken(seats.holdToken);
                                                }
                                                sessionStorage.removeItem('seatsio');
                                                setSelectedDate(dateOption);
                                                setOrderItems([]);
                                            }
                                        }}
                                    >
                                        <div className="figma-date-text">
                                            {moment.utc(dateOption.eventDate).format('MMM DD, YYYY')}
                                        </div>
                                        <div className="figma-time-text">
                                            {getEventTimeRange(dateOption)}
                                        </div>
                                        {dateOption.disabled && (
                                            <div
                                                className="figma-selected-badge"
                                                style={{
                                                    position: 'static',
                                                    marginTop: '12px',
                                                    display: 'inline-flex',
                                                    background: '#ef4444'
                                                }}
                                            >
                                                Sold Out
                                            </div>
                                        )}
                                        {!dateOption.disabled && selectedDate?.gid === dateOption.gid && (
                                            <div
                                                className="figma-selected-badge"
                                                style={{
                                                    position: 'static',
                                                    marginTop: '12px',
                                                    display: 'inline-flex',
                                                    background: eventDetails?.primaryColor || '#2563eb'
                                                }}
                                            >
                                                ✓ Selected
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Right Scroll Indicator & Button (Mobile View only) */}
                            {mobileView && eventDetails?.eventPageDateTimes?.length > 1 && canScrollRight && (
                                <>
                                    <div style={{
                                        position: 'absolute',
                                        right: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: '40px',
                                        background: 'linear-gradient(to left, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0))',
                                        pointerEvents: 'none',
                                        zIndex: 5
                                    }} />
                                    <button
                                        onClick={scrollRightFn}
                                        style={{
                                            position: 'absolute',
                                            right: '4px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            zIndex: 10,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            background: '#ffffff',
                                            border: '1px solid #e2e8f0',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                                            cursor: 'pointer',
                                            color: eventDetails?.primaryColor || '#2563eb',
                                            padding: 0
                                        }}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg>
                                    </button>
                                </>
                            )}
                        </div>
                    )}
                </div>

                {/* Seated Event Selected Seats Card or Banner Carousel */}
                {eventDetails?.isSeatedEvent && (
                    showBannerImage ? (
                        <div className="figma-banner-container" style={{ height: mobileView ? '300px' : '400px', width: '100%', overflow: 'hidden', borderRadius: '16px', marginBottom: '8px', position: 'relative', background: '#f1f5f9', border: '1px solid #e2e8f0' }}>
                            {bannerImages.length > 0 ? (
                                bannerImages.map((img, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            opacity: idx === currentImageIndex ? 1 : 0,
                                            zIndex: idx === currentImageIndex ? 1 : 0,
                                            pointerEvents: idx === currentImageIndex ? 'auto' : 'none',
                                            transition: 'opacity 0.8s ease-in-out',
                                            cursor: 'pointer',
                                            overflow: 'hidden'
                                        }}
                                        onClick={() => openImageModal(img)}
                                    >
                                        <img
                                            src={img}
                                            alt=""
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                filter: 'blur(20px) brightness(0.8)',
                                                transform: 'scale(1.1)',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                        <img
                                            src={img}
                                            alt={`Event Banner ${idx}`}
                                            className="figma-banner-image"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                position: 'relative',
                                                zIndex: 1,
                                                opacity: 1
                                            }}
                                        />
                                    </div>
                                ))
                            ) : (
                                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#e2e8f0', color: '#94a3b8' }}>
                                    No Image Available
                                </div>
                            )}

                            {bannerImages.length > 1 && (
                                <>
                                    <button 
                                        className="figma-banner-nav-btn prev" 
                                        onClick={prevImage}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '20px',
                                            transform: 'translateY(-50%)',
                                            zIndex: 10,
                                            background: 'rgba(255, 255, 255, 0.2)',
                                            backdropFilter: 'blur(10px)',
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s',
                                            color: 'white',
                                            fontSize: '16px'
                                        }}
                                    >
                                        <LeftOutlined />
                                    </button>
                                    <button 
                                        className="figma-banner-nav-btn next" 
                                        onClick={nextImage}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: '20px',
                                            transform: 'translateY(-50%)',
                                            zIndex: 10,
                                            background: 'rgba(255, 255, 255, 0.2)',
                                            backdropFilter: 'blur(10px)',
                                            border: '1px solid rgba(255, 255, 255, 0.3)',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s',
                                            color: 'white',
                                            fontSize: '16px'
                                        }}
                                    >
                                        <RightOutlined />
                                    </button>
                                    <div className="figma-banner-dots" style={{
                                        position: 'absolute',
                                        bottom: '20px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        zIndex: 10,
                                        display: 'flex',
                                        gap: '8px',
                                        background: 'rgba(0,0,0,0.2)',
                                        padding: '6px 12px',
                                        borderRadius: '20px',
                                        backdropFilter: 'blur(4px)'
                                    }}>
                                        {bannerImages.map((_, idx) => (
                                            <div 
                                                key={idx}
                                                onClick={(e) => { e.stopPropagation(); setCurrentImageIndex(idx); }}
                                                style={{
                                                    width: '8px',
                                                    height: '8px',
                                                    borderRadius: '50%',
                                                    background: idx === currentImageIndex ? 'white' : 'rgba(255,255,255,0.4)',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s'
                                                }}
                                            />
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (<></>)
                )}

                {/* Custom Information Form */}
                {customInfoValues.length > 0 && (
                    <div
                        className="figma-info-form-card"
                        style={{
                            background: "#fff",
                            padding: mobileView ? "20px" : "32px",
                            borderRadius: "16px",
                            marginTop: "0px",
                            border: "1px solid #e2e8f0",
                            boxSizing: "border-box"
                        }}
                    >
                        <h2 style={{ fontSize: mobileView ? "18px" : "20px", fontWeight: "700", marginBottom: mobileView ? "20px" : "28px", color: "#111827", letterSpacing: '-0.015em' }}>
                            Custom Information
                        </h2>
                        <div
                            className="figma-form-grid"
                        >
                            {customInfoValues.map((customInfo, index) => (
                                <div key={index} className="figma-form-field">
                                    <label
                                        style={{
                                            display: "block",
                                            marginBottom: "10px",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "#4b5563",
                                        }}
                                    >
                                        {customInfo?.inputFieldLabel} {!customInfo.isOptional && <span style={{ color: "#ef4444" }}>*</span>}
                                    </label>
                                    {customInfo?.inputFieldLabel.toLowerCase().includes("phone") || customInfo?.inputFieldType === "INPUT_PHONE" ? (
                                        <div style={{ display: "flex", gap: "8px" }}>
                                            <Select
                                                options={COUNTRIES_LIST.map((c) => ({
                                                    value: c.dial_code,
                                                    label: `${c.dial_code}`,
                                                }))}
                                                value={{
                                                    value: countryCode,
                                                    label: countryCode,
                                                }}
                                                onChange={(val) => setCountryCode(val.value)}
                                                styles={{
                                                    container: (base) => ({
                                                        ...base,
                                                        width: mobileView ? "100px" : "140px",
                                                    }),
                                                    control: (base) => ({
                                                        ...base,
                                                        height: "50px",
                                                        borderRadius: "10px",
                                                        border: "1px solid #d1d5db",
                                                        fontSize: "15px",
                                                        backgroundColor: "#fff",
                                                        boxShadow: "none",
                                                        "&:hover": {
                                                            borderColor: "#d1d5db",
                                                        },
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        padding: "0 12px",
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: "50px",
                                                    }),
                                                }}
                                                placeholder="Code"
                                                isSearchable={true}
                                                components={{
                                                    IndicatorSeparator: () => null,
                                                }}
                                            />
                                            <input
                                                className="input-box"
                                                type="text"
                                                placeholder={`Enter your ${customInfo?.inputFieldLabel.toLowerCase()}`}
                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                                value={customInfo.value}
                                                style={{
                                                    flex: 1,
                                                    padding: "14px 16px",
                                                    borderRadius: "10px",
                                                    border: "1px solid #d1d5db",
                                                    fontSize: "15px",
                                                    boxSizing: "border-box",
                                                    margin: 0
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <input
                                            className="input-box"
                                            type={customInfo?.inputFieldType === "INPUT_EMAIL" ? "email" : "text"}
                                            placeholder={`Enter your ${customInfo?.inputFieldLabel.toLowerCase()}`}
                                            onChange={(e) => handleInputChange(index, e.target.value)}
                                            value={customInfo.value}
                                            style={{
                                                width: "100%",
                                                padding: "14px 16px",
                                                borderRadius: "10px",
                                                border: "1px solid #d1d5db",
                                                fontSize: "15px",
                                                boxSizing: "border-box",
                                                margin: 0
                                            }}
                                        />
                                    )}
                                    <div style={{ marginTop: "8px" }}>
                                        <SpError fontSize="12px" color="#ef4444">
                                            {customInfo &&
                                                !customInfo.isOptional &&
                                                simpleValidator.current.message(
                                                    customInfo?.inputFieldLabel,
                                                    customInfo.value,
                                                    "required"
                                                )}
                                        </SpError>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Product Selection Tabs */}
                {sortedProducts.length > 0 && (
                    <div className="figma-tabs-container">
                        {sortedProducts.map((p) => (
                            <div
                                key={p.gid}
                                className={`figma-tab ${activeTab === p.gid ? "active" : ""}`}
                                style={activeTab === p.gid ? {
                                    color: eventDetails?.primaryColor || '#2563eb',
                                    borderBottomColor: eventDetails?.primaryColor || '#2563eb',
                                    background: `${eventDetails?.primaryColor || '#2563eb'}10`
                                } : {}}
                                onClick={() => setActiveTab(p.gid)}
                            >
                                {p.eventPageProductType === "TICKET"
                                    ? "Ticket Details"
                                    : p.eventPageProductType === "FOOD"
                                        ? "Food Details"
                                        : p.eventPageProductName}
                            </div>
                        ))}
                    </div>
                )}

                {/* Product List */}
                <div className={sortedProducts?.length > 0 ? "figma-items-list-card" : ""}>
                    {sortedProducts
                        .filter((p) => !activeTab || p.gid === activeTab)
                        .map((eventPageProduct) => (
                            <div key={eventPageProduct.gid}>
                                {/* Regular items (tickets/food) */}
                                {eventPageProduct?.items?.length > 0 &&
                                    eventPageProduct.items.map((item) => (
                                        <React.Fragment key={item.gid}>
                                            <div className="figma-line-item">
                                                <div className="figma-line-item-info">
                                                    <h3 className="figma-line-item-name">{item.displayName}</h3>
                                                    {item.price > 0 && (
                                                        <p className="figma-line-item-price">
                                                            {item.coupon && Number(orderDiscount) === 0 ? (
                                                                <>
                                                                    <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '13px', marginRight: '8px' }}>
                                                                        $ {AmountDivideByHundred(item.price)}
                                                                    </span>
                                                                    <span style={{ fontWeight: '700' }}>
                                                                        $ {(() => {
                                                                            const qty = updates.find((u) => u.itemGid === item.gid && u.productGid === eventPageProduct.gid && u.listedItem)?.quantity || 1;
                                                                            const unitDiscount = item.coupon.percentageOff 
                                                                                ? Math.round(item.price * (item.coupon.percentageOff / 100))
                                                                                : Math.abs(item.coupon.amountOff || 0);
                                                                            return AmountDivideByHundred((item.price - unitDiscount) * qty);
                                                                        })()}
                                                                    </span>
                                                                    <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
                                                                        - Discount: ${(() => {
                                                                            const qty = updates.find((u) => u.itemGid === item.gid && u.productGid === eventPageProduct.gid && u.listedItem)?.quantity || 1;
                                                                            const unitDiscount = item.coupon.percentageOff 
                                                                                ? Math.round(item.price * (item.coupon.percentageOff / 100))
                                                                                : Math.abs(item.coupon.amountOff || 0);
                                                                            return AmountDivideByHundred(unitDiscount * qty);
                                                                        })()}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <span>$ {AmountDivideByHundred(item.price)}</span>
                                                            )}
                                                        </p>
                                                    )}
                                                </div>

                                                <div className="d-flex align-items-center" style={{ gap: "10px", flexDirection: "row" }}>
                                                    {console.log(updates,!updates.some((u) => u.itemGid === item.gid && u.productGid === eventPageProduct.gid && u.listedItem),eventPageProduct.gid ,item.gid, "updates111111111111111111")}
                                                    {!updates.some((u) => u.itemGid === item.gid && u.productGid === eventPageProduct.gid && u.listedItem) ? (
                                                        item.enableStock && item.onlineStock === 0 ? (
                                                            <img alt="" src={outOfStock} style={{ width: "64px", height: "64px" }} />
                                                        ) : (
                                                            <>
                                                            <button
                                                                className="figma-add-item-btn"
                                                                style={{ background: eventDetails?.primaryColor || '#2563eb' }}
                                                                disabled={item.enableStock && item.onlineStock === 0}
                                                                onClick={() => {
                                                                    updateQuantity(null, item, null, null, 1, 0, undefined, eventPageProduct.gid);
                                                                    if (item.modifierGroups?.length > 0) setActiveModifier(item.gid);
                                                                }}
                                                            >
                                                                Add Item
                                                            </button>
                                                            </>
                                                        )
                                                    ) : (
                                                         <div style={{ display: "flex", flexDirection: "column" }}>
                                                             <div
                                                                 className="figma-quantity-selector"
                                                                 style={{
                                                                     display: "flex",
                                                                     flexDirection: "row",
                                                                     alignItems: "center",
                                                                     justifyContent: "space-between",
                                                                     backgroundColor: "#FFFFFF",
                                                                     borderRadius: "5px",
                                                                     overflow: "hidden",
                                                                 }}
                                                             >
                                                                 <button
                                                                     className="increase-decrease-button"
                                                                     style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                     onClick={() => {
                                                                         const qty = updates.find((u) => u.itemGid === item.gid && u.productGid === eventPageProduct.gid && u.listedItem)?.quantity || 0;
                                                                         updateQuantity(null, item, null, null, -1, 0, undefined, eventPageProduct.gid);
                                                                         if (qty === 1 && activeModifier === item.gid) setActiveModifier(null);
                                                                     }}
                                                                 >
                                                                     –
                                                                 </button>
                                                                 <input
                                                                     type="text"
                                                                     className="input-item"
                                                                     value={updates.find((u) => u.itemGid === item.gid && u.listedItem)?.quantity || 0}
                                                                 />
                                                                 {!(item.enableStock && updates.find((u) => u.itemGid === item.gid && u.listedItem)?.quantity >= item.onlineStock) && (
                                                                     <button
                                                                         className="increase-decrease-button"
                                                                         style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: '#fff', background: eventDetails?.primaryColor || '#2563eb' }}
                                                                         onClick={() => {
                                                                             updateQuantity(null, item, null, null, 1, 0, undefined, eventPageProduct.gid);
                                                                             if (item.modifierGroups?.length > 0) setActiveModifier(item.gid);
                                                                         }}
                                                                     >
                                                                         +
                                                                     </button>
                                                                 )}
                                                             </div>
                                                             {/* {item.modifierGroups?.length > 0 &&
                                                                 updates.find((u) => u.itemGid === item.gid && u.listedItem)?.quantity > 0 && (
                                                                     <button
                                                                         className="drop-down-menu"
                                                                         style={{
                                                                             background: `${eventDetails?.primaryColor || '#2563eb'}0a`,
                                                                             borderColor: `${eventDetails?.primaryColor || '#2563eb'}30`,
                                                                             color: eventDetails?.primaryColor || '#2563eb',
                                                                             marginTop: '12px',
                                                                             justifyContent: 'center'
                                                                         }}
                                                                         onClick={() => {
                                                                             duplicateItem(null, item);
                                                                             if (item.modifierGroups?.length > 0) setActiveModifier(item.gid);
                                                                         }}
                                                                     >
                                                                         <u>Add To Order</u>
                                                                     </button>
                                                                 )} */}
                                                         </div>
                                                    )}
                                                </div>
                                            </div>

                                            {item.modifierGroups?.length > 0 && (
                                                <div style={{ width: "100%", position: "relative", margin: "5px 0 0", padding: "5px" }}>
                                                    <button
                                                        className="drop-down-menu"
                                                        style={{
                                                            background: `${eventDetails?.primaryColor || '#2563eb'}0a`,
                                                            borderColor: `${eventDetails?.primaryColor || '#2563eb'}30`,
                                                            color: eventDetails?.primaryColor || '#2563eb'
                                                        }}
                                                        onClick={() => toggleModifier(item.gid)}
                                                        disabled={item.enableStock && item.onlineStock === 0}
                                                    >
                                                        Add Modifications &#9660;
                                                    </button>

                                                    {activeModifier === item.gid && (
                                                        <div style={{
                                                            marginTop: "10px",
                                                            marginLeft: mobileView ? "10px" : "20px",
                                                            background: `${eventDetails?.primaryColor || '#2563eb'}08`,
                                                            border: `1px solid ${eventDetails?.primaryColor || '#2563eb'}20`,
                                                            borderRadius: "8px",
                                                            padding: "16px"
                                                        }}>
                                                            {item.modifierGroups.map((modifierGroup) => (
                                                                <div key={modifierGroup.gid} style={{ marginBottom: "5px" }}>
                                                                    <h4
                                                                        className="additional-info mb-2"
                                                                        style={{ fontStyle: "normal", color: "#000000" }}
                                                                    >
                                                                        {modifierGroup.name}{" "}
                                                                        {modifierGroup?.minRequired || modifierGroup?.maxAllowed
                                                                            ? `(${modifierGroup.minRequired ? "choose " + modifierGroup.minRequired : ""} ${modifierGroup.maxAllowed ? "max " + modifierGroup.maxAllowed : ""
                                                                            })`
                                                                            : ""}
                                                                    </h4>

                                                                    {modifierGroup?.modifiers.map((mod, modIndex) => {
                                                                        const itemInUpdates = updates.find((u) => u.itemGid === item.gid && u.productGid === eventPageProduct.gid && u.listedItem);
                                                                        const modifiersInGroup = itemInUpdates?.lineItemModifiers.filter((lineItemModifier) =>
                                                                            modifierGroup.modifiers.some((modifier) => lineItemModifier.modifierGid === modifier.gid)
                                                                        ) || [];
                                                                        const modifierQuantityTotal = modifiersInGroup.reduce(
                                                                            (sum, lineItemModifier) => sum + (lineItemModifier.quantity || 0),
                                                                            0
                                                                        );
                                                                        const modifierInItem = itemInUpdates?.lineItemModifiers.find((m) => m.modifierGid === mod.gid);
                                                                        const disableModifier =
                                                                            !mod.available ||
                                                                            (mod?.maxStackableQuantity && modifierInItem?.quantity >= mod.maxStackableQuantity) ||
                                                                            (modifierGroup?.maxAllowed && modifierQuantityTotal >= modifierGroup.maxAllowed);

                                                                        return (
                                                                            <div
                                                                                key={mod.gid}
                                                                                className="d-flex align-items-center justify-content-between"
                                                                                style={{
                                                                                    paddingTop: "12px",
                                                                                    paddingBottom: "12px",
                                                                                    borderTop: modIndex === 0 ? "none" : "1px solid #f1f5f9",
                                                                                }}
                                                                            >
                                                                                <div>
                                                                                    <p>{mod.name}</p>
                                                                                    {mod.price > 0 && (
                                                                                    <p style={{ margin: "5px 0 0", color: "#555", padding: "5px" }}>
                                                                                        $ {AmountDivideByHundred(mod.price)}
                                                                                    </p>
                                                                                    )}
                                                                                </div>

                                                                                {modifierInItem ? (
                                                                                    <div
                                                                                        className="d-flex align-items-center justify-content-between overflow-hidden figma-quantity-selector"
                                                                                        style={{
                                                                                            backgroundColor: "#FFFFFF",
                                                                                            borderRadius: "5px",
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            className="increase-decrease-button"
                                                                                            style={{ padding: "6px 12px", borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                                            onClick={() => updateQuantity(null, item, mod, null, -1, 0, undefined, eventPageProduct.gid)}
                                                                                        >
                                                                                            –
                                                                                        </button>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="input-item"
                                                                                            value={modifierInItem?.quantity || 0}
                                                                                        />
                                                                                        {!disableModifier && (
                                                                                            <button
                                                                                                className="increase-decrease-button"
                                                                                                style={{ padding: "6px 12px", borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                                                onClick={() => updateQuantity(null, item, mod, null, 1, 0, undefined, eventPageProduct.gid)}
                                                                                                disabled={disableModifier}
                                                                                            >
                                                                                                +
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                ) : (
                                                                                    <button
                                                                                        className="add-button"
                                                                                        style={{
                                                                                            padding: "8px 16px",
                                                                                            background: !disableModifier ? (eventDetails?.primaryColor || '#2563eb') : 'rgba(0,0,0,0.12)',
                                                                                            color: '#fff',
                                                                                            border: 'none'
                                                                                        }}
                                                                                        disabled={disableModifier}
                                                                                        onClick={() => updateQuantity(null, item, mod, null, 1, 0, undefined, eventPageProduct.gid)}
                                                                                    >
                                                                                        Add
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {item.modifierGroups?.map((modifierGroup) => {
                                                const itemInUpdates = updates.find((u) => u.itemGid === item.gid && u.listedItem);
                                                const modifiersInGroup = itemInUpdates?.lineItemModifiers.filter((lineItemModifier) =>
                                                    modifierGroup.modifiers.some((modifier) => lineItemModifier.modifierGid === modifier.gid)
                                                ) || [];
                                                const modifierQuantityTotal = modifiersInGroup.reduce(
                                                    (sum, lineItemModifier) => sum + (lineItemModifier.quantity || 0),
                                                    0
                                                );

                                                let updateValidationError = [...validationErrors];
                                                const validationErrorIndex = updateValidationError.findIndex(
                                                    (update) =>
                                                        update.uniqueGid === modifierGroup.gid + "&" + item.gid &&
                                                        update.productGid === eventPageProduct.gid
                                                );

                                                if (modifierGroup.minRequired && itemInUpdates?.quantity > 0) {
                                                    if (modifierQuantityTotal < modifierGroup.minRequired) {
                                                        if (validationErrorIndex === -1) {
                                                            updateValidationError.push({
                                                                uniqueGid: modifierGroup.gid + "&" + item.gid,
                                                                itemGid: item.gid,
                                                                productGid: eventPageProduct.gid,
                                                                errorMessage: `Add Modification -> "${modifierGroup.name}" : for Item -> "${item.displayName}"`,
                                                            });
                                                            setValidationErrors(updateValidationError);
                                                        }
                                                    } else {
                                                        if (validationErrorIndex !== -1) {
                                                            updateValidationError = updateValidationError.filter(
                                                                (_, index) => index !== validationErrorIndex
                                                            );
                                                            setValidationErrors(updateValidationError);
                                                        }
                                                    }
                                                } else {
                                                    if (validationErrorIndex !== -1) {
                                                        updateValidationError = updateValidationError.filter(
                                                            (_, index) => index !== validationErrorIndex
                                                        );
                                                        setValidationErrors(updateValidationError);
                                                    }
                                                }
                                                return null;
                                            })}

                                            {/* Duplicated regular items */}
                                            {updates
                                                .filter((lineItem) => lineItem.itemGid === item.gid && !lineItem.listedItem)
                                                .map((lineItem, lineIndex) => (
                                                    <div
                                                        key={lineIndex}
                                                        className="figma-line-item-card"
                                                        style={{ marginTop: '16px' }}
                                                    >
                                                        <div className="figma-line-item-header">
                                                            <div>
                                                                <h3 style={{ margin: "10px 0 0", fontSize: "18px", padding: "5px" }}>
                                                                    {lineItem.name}
                                                                </h3>
                                                                {lineItem.seats?.length > 0 && (
                                                                    <p className="additional-info">Seats: [{lineItem.seats.join(", ")}]</p>
                                                                )}
                                                                    {lineItem.lineItemDiscounts?.length > 0 && Number(orderDiscount) === 0 ? (
                                                                        <>
                                                                            <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '13px', marginRight: '8px' }}>
                                                                                $ {lineItem.price ? AmountDivideByHundred(lineItem.price) : "0.00"}
                                                                            </span>
                                                                            <span style={{ fontWeight: '700' }}>
                                                                                $ {(() => {
                                                                                    const disc = lineItem.lineItemDiscounts[0];
                                                                                    const discountAmount = disc.percentageOff 
                                                                                        ? Math.round(lineItem.price * (disc.percentageOff / 100))
                                                                                        : Math.abs(disc.amountOff || 0);
                                                                                    return AmountDivideByHundred(lineItem.price - discountAmount);
                                                                                })()}
                                                                            </span>
                                                                            <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
                                                                                - Discount: ${(() => {
                                                                                    const disc = lineItem.lineItemDiscounts[0];
                                                                                    const discountAmount = disc.percentageOff 
                                                                                        ? Math.round(lineItem.price * (disc.percentageOff / 100))
                                                                                        : Math.abs(disc.amountOff || 0);
                                                                                    return AmountDivideByHundred(discountAmount);
                                                                                })()}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <span>$ {lineItem.price ? AmountDivideByHundred(lineItem.price) : "0.00"}</span>
                                                                    )}
                                                            </div>

                                                            <div
                                                                className="figma-quantity-selector"
                                                                style={{
                                                                    display: "flex",
                                                                    flexDirection: "row",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    backgroundColor: "#FFFFFF",
                                                                    borderRadius: "5px",
                                                                    overflow: "hidden",
                                                                }}
                                                            >
                                                                <button
                                                                    className="increase-decrease-button"
                                                                    style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                    onClick={() => updateQuantity(null, item, null, null, -1, 0, lineItem.duplicateIndex, eventPageProduct.gid)}
                                                                >
                                                                    –
                                                                </button>
                                                                <input
                                                                    type="text"
                                                                    className="input-item"
                                                                    value={lineItem?.quantity || 0}
                                                                />
                                                                {!(item?.enableStock && lineItem?.quantity >= item?.onlineStock) && (
                                                                    <button
                                                                        className="increase-decrease-button"
                                                                        style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: '#fff', background: eventDetails?.primaryColor || '#2563eb' }}
                                                                        onClick={() => updateQuantity(null, item, null, null, 1, 0, lineItem.duplicateIndex, eventPageProduct.gid)}
                                                                    >
                                                                        +
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {lineItem.lineItemModifiers?.length > 0 && (
                                                            <div style={{ padding: "5px" }}>
                                                                <p className="additional-info">Modifiers:</p>
                                                                {lineItem.lineItemModifiers.map((lineItemModifier, idx) => (
                                                                    <p
                                                                        key={idx}
                                                                        style={{ margin: "7.5px 20px", fontSize: "14px", color: "#555" }}
                                                                    >
                                                                        {lineItemModifier.name} (${lineItemModifier.price ? AmountDivideByHundred(lineItemModifier.price) : "0.00"} x
                                                                        {lineItemModifier.quantity})
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {lineItem.lineItemItems?.length > 0 && (
                                                            <>
                                                                <p className="additional-info" style={{ padding: "5px" }}>
                                                                    Items:
                                                                </p>
                                                                {lineItem.lineItemItems.map((lineItemItem, idx) => (
                                                                    <div style={{ padding: "5px" }} key={idx}>
                                                                        <p
                                                                            style={{ margin: "7.5px 20px", fontSize: "14px", color: "#555" }}
                                                                        >
                                                                            {lineItemItem.name} (
                                                                            {lineItemItem.lineItemModifiers?.length > 0
                                                                                ? `($${lineItemItem.price ? AmountDivideByHundred(lineItemItem.price) : "0.00"} + (M - $${AmountDivideByHundred(
                                                                                    lineItemItem.lineItemModifiers.reduce((sum, m) => sum + m.quantity * m.price, 0)
                                                                                )}))`
                                                                                : `$${lineItemItem.price ? AmountDivideByHundred(lineItemItem.price) : "0.00"}`}{" "}
                                                                            x {lineItemItem.quantity})
                                                                            {lineItemItem.lineItemDiscounts?.length > 0 && Number(orderDiscount) === 0 ? (
                                                                                <div style={{ marginTop: '4px' }}>
                                                                                    <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '12px', marginRight: '6px' }}>
                                                                                        $ {lineItemItem.price ? AmountDivideByHundred(lineItemItem.price) : "0.00"}
                                                                                    </span>
                                                                                    <span style={{ fontWeight: '600', fontSize: '13px' }}>
                                                                                        $ {(() => {
                                                                                            const disc = lineItemItem.lineItemDiscounts[0];
                                                                                            const discountAmount = disc.percentageOff 
                                                                                                ? Math.round(lineItemItem.price * (disc.percentageOff / 100))
                                                                                                : Math.abs(disc.amountOff || 0);
                                                                                            return AmountDivideByHundred(lineItemItem.price - discountAmount);
                                                                                        })()}
                                                                                    </span>
                                                                                    <span style={{ fontSize: '11px', color: '#ef4444', marginLeft: '8px' }}>
                                                                                        (-${(() => {
                                                                                            const disc = lineItemItem.lineItemDiscounts[0];
                                                                                            const discountAmount = disc.percentageOff 
                                                                                                ? Math.round(lineItemItem.price * (disc.percentageOff / 100))
                                                                                                : Math.abs(disc.amountOff || 0);
                                                                                            return AmountDivideByHundred(discountAmount);
                                                                                        })()})
                                                                                    </span>
                                                                                </div>
                                                                            ) : null}
                                                                        </p>

                                                                        {lineItemItem.lineItemModifiers?.length > 0 && (
                                                                            <>
                                                                                <p className="additional-info" style={{ margin: "7.5px 20px", padding: "5px" }}>
                                                                                    Modifiers(M):
                                                                                </p>
                                                                                {lineItemItem.lineItemModifiers.map((m, mIdx) => (
                                                                                    <p
                                                                                        key={`${idx}-${mIdx}`}
                                                                                        style={{ margin: "7.5px 40px", fontSize: "14px", color: "#555", padding: "5px" }}
                                                                                    >
                                                                                        {m.name} (${m.price ? AmountDivideByHundred(m.price) : "0.00"} x {m.quantity})
                                                                                    </p>
                                                                                ))}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}
                                                    </div>
                                                ))}
                                        </React.Fragment>
                                    ))}

                                {/* Custom items */}
                                {eventPageProduct?.customItems?.length > 0 &&
                                    eventPageProduct.customItems.map((customItem, index) => (
                                        <React.Fragment key={customItem.gid || index}>
                                            <div className="figma-line-item">
                                                <div className="figma-line-item-info">
                                                    <h3 className="figma-line-item-name">
                                                        {customItem.inputFieldLabel}
                                                        {!customItem.isOptional && <span style={{ color: "#ef4444", marginLeft: "4px" }}>*</span>}
                                                    </h3>
                                                    {(() => {
                                                        const customItemInUpdates = updates.find(
                                                            (u) => u.customItemGid === customItem.gid && u.listedItem
                                                        );
                                                        if (customItemInUpdates && customItemInUpdates.seats) {
                                                            return <p className="figma-line-item-seats">Seats: [{customItemInUpdates.seats.join(", ")}]</p>;
                                                        }
                                                        return null;
                                                    })()}
                                                    {/* For non-seated events: show base price */}
                                                    {!updates.some(u => u.customItemGid === customItem.gid && u.seatLabel) && customItem.amount > 0 && (
                                                        <p className="figma-line-item-price">
                                                            {customItem.coupon && Number(orderDiscount) === 0 ? (
                                                                <>
                                                                    <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '13px', marginRight: '8px' }}>
                                                                        $ {customItem.amount ? AmountDivideByHundred(customItem.amount) : "0.00"}
                                                                    </span>
                                                                    <span style={{ fontWeight: '700' }}>
                                                                        $ {(() => {
                                                                            const discountAmount = customItem.coupon.percentageOff 
                                                                                ? Math.round(customItem.amount * (customItem.coupon.percentageOff / 100))
                                                                                : Math.abs(customItem.coupon.amountOff || 0);
                                                                            return AmountDivideByHundred(customItem.amount - discountAmount);
                                                                        })()}
                                                                    </span>
                                                                    <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
                                                                        - Discount: ${(() => {
                                                                            const discountAmount = customItem.coupon.percentageOff 
                                                                                ? Math.round(customItem.amount * (customItem.coupon.percentageOff / 100))
                                                                                : Math.abs(customItem.coupon.amountOff || 0);
                                                                            return AmountDivideByHundred(discountAmount);
                                                                        })()}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <span>$ {customItem.amount ? AmountDivideByHundred(customItem.amount) : "0.00"}</span>
                                                            )}
                                                        </p>
                                                    )}

                                                    {/* Per-seat ticket type breakdown for seated events */}
                                                    {(() => {
                                                        const seatedLineItems = updates.filter(
                                                            (u) => u.customItemGid === customItem.gid && u.seatLabel
                                                        );
                                                        if (seatedLineItems.length === 0) return null;
                                                        return (
                                                            <div style={{ marginTop: '10px', borderTop: '1px solid #f1f5f9', paddingTop: '10px' }}>
                                                                {seatedLineItems.map((seatItem, sIdx) => {
                                                                    return (
                                                                        <div key={sIdx} style={{ paddingBottom: '10px', marginBottom: sIdx < seatedLineItems.length - 1 ? '10px' : 0, borderBottom: sIdx < seatedLineItems.length - 1 ? '1px dashed #f1f5f9' : 'none' }}>
                                                                            {/* Ticket Type + Price */}
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                                <div style={{ fontSize: '13px', color: '#475569', fontWeight: '600' }}>
                                                                                    {seatItem?.name}
                                                                                </div>
                                                                                {seatItem.price > 0 && (
                                                                                <div style={{ fontWeight: '700', color: '#1e293b', fontSize: '14px', marginLeft: '12px', whiteSpace: 'nowrap' }}>
                                                                                    ${AmountDivideByHundred(seatItem.price)}
                                                                                </div>
                                                                                )}
                                                                            </div>
                                                                            {/* Seat label */}
                                                                            {seatItem.seats?.length > 0 && (
                                                                                <div style={{ fontSize: '12px', color: '#64748b', marginTop: '3px' }}>
                                                                                    Seat: {seatItem.seats.join(', ')}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        );
                                                    })()}
                                                    {((customItem.minQuantity && customItem.minQuantity > 0) || (customItem.maxQuantity && customItem.maxQuantity > 0)) && (
                                                        <div style={{ display: 'flex', gap: '8px', marginTop: '8px', marginBottom: '16px' }}>
                                                            {customItem.minQuantity && customItem.minQuantity > 0 ? (
                                                                <div style={{ 
                                                                    fontSize: '10px', 
                                                                    background: '#f1f5f9', 
                                                                    color: '#475569', 
                                                                    padding: '3px 10px', 
                                                                    borderRadius: '6px', 
                                                                    fontWeight: '700',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    letterSpacing: '0.01em',
                                                                    border: '1px solid #e2e8f0'
                                                                }}>
                                                                    MIN: {customItem.minQuantity}
                                                                </div>
                                                            ) : null}
                                                            {customItem.maxQuantity && customItem.maxQuantity > 0 ? (
                                                                <div style={{ 
                                                                    fontSize: '10px', 
                                                                    background: '#f1f5f9', 
                                                                    color: '#475569', 
                                                                    padding: '3px 10px', 
                                                                    borderRadius: '6px', 
                                                                    fontWeight: '700',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    letterSpacing: '0.01em',
                                                                    border: '1px solid #e2e8f0'
                                                                }}>
                                                                    MAX: {customItem.maxQuantity}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    )}
                                                    {(() => {
                                                        if (!customItem.isOptional) {
                                                            let updateMandatoryItems = [...mandatoryItems];
                                                            const itemIndex = updateMandatoryItems.findIndex(
                                                                (update) => update.customItemGid === customItem.gid
                                                            );
                                                            if (itemIndex === -1) {
                                                                updateMandatoryItems.push({
                                                                    customItemGid: customItem.gid,
                                                                    errorMessage: `Add ${customItem.inputFieldLabel} To Proceed`,
                                                                });
                                                                setMandatoryItems(updateMandatoryItems);
                                                                setTimeout(() => setUpdateOrderItem(true), 500);
                                                            }
                                                        }
                                                        return null;
                                                    })()}
                                                </div>

                                                <div className="d-flex align-items-center" style={{ gap: "10px", flexDirection: "row" }}>
                                                    {(() => {
                                                        const itemInUpdates = updates.find(
                                                            (u) => u.customItemGid === customItem.gid && u.listedItem
                                                        );
                                                        const currentQty = itemInUpdates?.quantity || 0;
                                                        const isOutOfStock = customItem.enableStock && (customItem.stockQuantity === 0 || customItem.onlineStock === 0);
                                                        const isAtMaxStock = (customItem.enableStock && (
                                                            (customItem.stockQuantity !== undefined && currentQty >= customItem.stockQuantity) ||
                                                            (customItem.onlineStock !== undefined && currentQty >= customItem.onlineStock)
                                                        )) || (customItem.maxQuantity && currentQty >= customItem.maxQuantity);

                                                        if (!itemInUpdates) {
                                                            return isOutOfStock ? (
                                                                <button
                                                                    className="figma-add-item-btn"
                                                                    disabled={true}
                                                                    style={{ background: '#94a3b8', color: '#fff', fontWeight: '600', cursor: 'not-allowed' }}
                                                                >
                                                                    Sold Out
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="figma-add-item-btn"
                                                                    style={{ background: eventDetails?.primaryColor || '#2563eb' }}
                                                                    onClick={() => {
                                                                        updateQuantity(customItem, null, null, null, 1, 0, undefined, eventPageProduct.gid);
                                                                        if (customItem.items?.length > 0) {
                                                                            setActiveItem(customItem.gid);
                                                                        } else if (customItem.modifierGroups?.length > 0) {
                                                                            setActiveModifier(customItem.gid);
                                                                        }
                                                                    }}
                                                                >
                                                                    Add Item
                                                                </button>
                                                            );
                                                        }

                                                        return (
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <div
                                                                    className="figma-quantity-selector"
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        alignItems: "center",
                                                                        justifyContent: "space-between",
                                                                        backgroundColor: "#FFFFFF",
                                                                        borderRadius: "5px",
                                                                        overflow: "hidden",
                                                                        gap: "4px",
                                                                        marginTop:
                                                                            (customItem.modifierGroups?.length > 0 || customItem.items?.length > 0) &&
                                                                                currentQty > 0
                                                                                ? "10px"
                                                                                : "",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="increase-decrease-button"
                                                                        style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                        onClick={() => {
                                                                            updateQuantity(customItem, null, null, null, -1, 0, undefined, eventPageProduct.gid);
                                                                            if (currentQty === 1) {
                                                                                if (activeItem === customItem.gid) setActiveItem(null);
                                                                                if (activeModifier === customItem.gid) setActiveModifier(null);
                                                                            }
                                                                        }}
                                                                    >
                                                                        –
                                                                    </button>
                                                                    <input
                                                                        type="text"
                                                                        className="input-item"
                                                                        value={currentQty}
                                                                        readOnly
                                                                    />
                                                                    {!isAtMaxStock ? (
                                                                        <button
                                                                            className="increase-decrease-button"
                                                                            style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: '#fff', background: eventDetails?.primaryColor || '#2563eb' }}
                                                                            onClick={() => {
                                                                                updateQuantity(customItem, null, null, null, 1, 0, undefined, eventPageProduct.gid);
                                                                                if (customItem.items?.length > 0) {
                                                                                    setActiveItem(customItem.gid);
                                                                                } else if (customItem.modifierGroups?.length > 0) {
                                                                                    setActiveModifier(customItem.gid);
                                                                                }
                                                                            }}
                                                                        >
                                                                            +
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="increase-decrease-button"
                                                                            disabled={true}
                                                                            style={{ borderColor: '#e2e8f0', color: '#94a3b8', background: '#f8fafc', cursor: 'not-allowed' }}
                                                                        >
                                                                            +
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>

                                            <div style={{ width: "100%" }}>
                                                {/* Modifier groups for custom item */}
                                                {customItem.modifierGroups?.length > 0 && (
                                                    <div style={{ position: "relative", margin: "5px 0 0", padding: "5px" }}>
                                                        <button
                                                                className="drop-down-menu"
                                                                style={{
                                                                    background: `${eventDetails?.primaryColor || '#2563eb'}0a`,
                                                                    borderColor: `${eventDetails?.primaryColor || '#2563eb'}30`,
                                                                    color: eventDetails?.primaryColor || '#2563eb'
                                                                }}
                                                                onClick={() => toggleModifier(customItem.gid)}
                                                            >
                                                            <span>Customize Your {customItem.inputFieldLabel}</span>
                                                            <span>{activeModifier === customItem.gid ? '▲' : '▼'}</span>
                                                        </button>

                                                        {activeModifier === customItem.gid && (
                                                            <div style={{
                                                                marginTop: "8px",
                                                                background: `${eventDetails?.primaryColor || '#2563eb'}08`,
                                                                border: `1px solid ${eventDetails?.primaryColor || '#2563eb'}20`,
                                                                borderRadius: "8px",
                                                                padding: "16px"
                                                            }}>
                                                                {customItem.modifierGroups.map((modifierGroup) => (
                                                                    <div key={modifierGroup.gid} style={{ marginBottom: "5px" }}>
                                                                        <h4
                                                                            className="additional-info mb-2"
                                                                            style={{ fontStyle: "normal", color: "#000000" }}
                                                                        >
                                                                            {modifierGroup.name}{" "}
                                                                            {modifierGroup?.minRequired || modifierGroup?.maxAllowed
                                                                                ? `(${modifierGroup.minRequired ? "choose " + modifierGroup.minRequired : ""} ${modifierGroup.maxAllowed ? "max " + modifierGroup.maxAllowed : ""
                                                                                })`
                                                                                : ""}
                                                                        </h4>

                                                                        {modifierGroup?.modifiers.map((mod, modIndex) => {
                                                                            const customItemInUpdates = updates.find(
                                                                                (u) => u.customItemGid === customItem.gid && u.productGid === eventPageProduct.gid && u.listedItem
                                                                            );
                                                                            const modifiersInGroup = customItemInUpdates?.lineItemModifiers.filter((m) =>
                                                                                modifierGroup.modifiers.some((mg) => m.modifierGid === mg.gid)
                                                                            ) || [];
                                                                            const modifierQuantityTotal = modifiersInGroup.reduce(
                                                                                (sum, m) => sum + (m.quantity || 0),
                                                                                0
                                                                            );
                                                                            const modifierInItem = customItemInUpdates?.lineItemModifiers.find(
                                                                                (m) => m.modifierGid === mod.gid
                                                                            );
                                                                            const disableModifier =
                                                                                !mod.available ||
                                                                                (mod?.maxStackableQuantity && modifierInItem?.quantity >= mod.maxStackableQuantity) ||
                                                                                (modifierGroup?.maxAllowed && modifierQuantityTotal >= modifierGroup.maxAllowed);

                                                                            return (
                                                                                <div
                                                                                    key={mod.gid}
                                                                                    className="d-flex align-items-center justify-content-between"
                                                                                    style={{
                                                                                        paddingTop: "12px",
                                                                                        paddingBottom: "12px",
                                                                                        borderTop: modIndex === 0 ? "none" : "1px solid #f1f5f9",
                                                                                    }}
                                                                                >
                                                                                    <div>
                                                                                        <p>{mod.name}</p>
                                                                                        {mod.price > 0 && (
                                                                                        <p style={{ margin: "5px 0 0", color: "#555", padding: "5px" }}>
                                                                                            $ {AmountDivideByHundred(mod.price)}
                                                                                        </p>
                                                                                        )}
                                                                                    </div>

                                                                                    {modifierInItem ? (
                                                                                        <div
                                                                                            className="figma-quantity-selector"
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                flexDirection: "row",
                                                                                                alignItems: "center",
                                                                                                justifyContent: "space-between",
                                                                                                backgroundColor: "#FFFFFF",
                                                                                                borderRadius: "5px",
                                                                                                overflow: "hidden",
                                                                                                gap: "4px",
                                                                                            }}
                                                                                        >
                                                                                            <button
                                                                                                className="increase-decrease-button"
                                                                                                style={{ padding: "6px 12px", borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                                                onClick={() => updateQuantity(customItem, null, mod, null, -1, 0, undefined, eventPageProduct.gid)}
                                                                                            >
                                                                                                –
                                                                                            </button>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="input-item"
                                                                                                value={modifierInItem?.quantity || 0}
                                                                                                readOnly
                                                                                            />
                                                                                            {!disableModifier && (
                                                                                                <button
                                                                                                    className="increase-decrease-button"
                                                                                                    style={{ padding: "6px 12px", borderColor: eventDetails?.primaryColor || '#2563eb', color: '#fff', background: eventDetails?.primaryColor || '#2563eb' }}
                                                                                                    onClick={() => updateQuantity(customItem, null, mod, null, 1, 0, undefined, eventPageProduct.gid)}
                                                                                                    disabled={disableModifier}
                                                                                                >
                                                                                                    +
                                                                                                </button>
                                                                                            )}
                                                                                        </div>
                                                                                    ) : (
                                                                                        <button
                                                                                            className="add-button"
                                                                                            style={{
                                                                                                padding: "8px 16px",
                                                                                                background: !disableModifier ? (eventDetails?.primaryColor || '#2563eb') : 'rgba(0,0,0,0.12)',
                                                                                                color: '#fff',
                                                                                                border: 'none'
                                                                                            }}
                                                                                            disabled={disableModifier}
                                                                                            onClick={() => updateQuantity(customItem, null, mod, null, 1, 0, undefined, eventPageProduct.gid)}
                                                                                        >
                                                                                            Add
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {customItem.modifierGroups?.map((modifierGroup) => {
                                                            const customItemInUpdates = updates.find(
                                                                (u) => u.customItemGid === customItem.gid && u.listedItem
                                                            );
                                                            const modifiersInGroup = customItemInUpdates?.lineItemModifiers.filter((m) =>
                                                                modifierGroup.modifiers.some((mg) => m.modifierGid === mg.gid)
                                                            ) || [];
                                                            const modifierQuantityTotal = modifiersInGroup.reduce(
                                                                (sum, m) => sum + (m.quantity || 0),
                                                                0
                                                            );

                                                            let updateValidationError = [...validationErrors];
                                                            const validationErrorIndex = updateValidationError.findIndex(
                                                                (update) =>
                                                                    update.uniqueGid === modifierGroup.gid + "&" + customItem.gid &&
                                                                    update.productGid === eventPageProduct.gid
                                                            );

                                                            if (modifierGroup.minRequired && customItemInUpdates?.quantity > 0) {
                                                                if (modifierQuantityTotal < modifierGroup.minRequired) {
                                                                    if (validationErrorIndex === -1) {
                                                                        updateValidationError.push({
                                                                            uniqueGid: modifierGroup.gid + "&" + customItem.gid,
                                                                            customItemGid: customItem.gid,
                                                                            productGid: eventPageProduct.gid,
                                                                            errorMessage: `Add Modifications -> "${modifierGroup.name}" : for Item -> "${customItem.inputFieldLabel}"`,
                                                                        });
                                                                        setValidationErrors(updateValidationError);
                                                                    }
                                                                } else if (validationErrorIndex !== -1) {
                                                                    updateValidationError = updateValidationError.filter(
                                                                        (_, i) => i !== validationErrorIndex
                                                                    );
                                                                    setValidationErrors(updateValidationError);
                                                                }
                                                            } else if (validationErrorIndex !== -1) {
                                                                updateValidationError = updateValidationError.filter((_, i) => i !== validationErrorIndex);
                                                                setValidationErrors(updateValidationError);
                                                            }
                                                            return null;
                                                        })}
                                                    </div>
                                                )}

                                                {/* Sub-items for custom item */}
                                                {customItem?.items?.length > 0 && (
                                                    <div style={{ position: "relative", margin: "5px 0 0", padding: "5px" }}>
                                                        <button
                                                            className="drop-down-menu"
                                                            style={{
                                                                background: `${eventDetails?.primaryColor || '#2563eb'}0a`,
                                                                borderColor: `${eventDetails?.primaryColor || '#2563eb'}30`,
                                                                color: eventDetails?.primaryColor || '#2563eb'
                                                            }}
                                                            onClick={() => toggleItem(customItem.gid)}
                                                        >
                                                            <span>Select Options</span>
                                                            <span>{activeItem === customItem.gid ? '▲' : '▼'}</span>
                                                        </button>

                                                        {activeItem === customItem.gid && (
                                                            <div style={{
                                                                marginTop: "8px",
                                                                background: "#FFFFFF",
                                                                border: "1px solid #E0E0E0",
                                                                borderRadius: "8px",
                                                                padding: "16px"
                                                            }}>
                                                                {customItem.items.map((subItem, subIndex) => (
                                                                    <div
                                                                        key={subIndex}
                                                                        style={{
                                                                            marginBottom: "12px",
                                                                            padding: mobileView ? "0" : "16px",
                                                                            borderTop: subIndex === 0 ? "none" : "1px solid #f1f5f9",
                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center justify-content-between">
                                                                            <div>
                                                                                <h3 style={{ margin: "10px 0 0", fontSize: "18px", padding: "5px" }}>
                                                                                    {subItem.displayName}
                                                                                </h3>
                                                                                {subItem.price > 0 && (
                                                                                    <p style={{ margin: "5px 0 0", color: "#555", padding: "5px" }}>
                                                                                        {subItem.coupon && Number(orderDiscount) === 0 ? (
                                                                                            <>
                                                                                                <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '13px', marginRight: '8px' }}>
                                                                                                    $ {AmountDivideByHundred(subItem.price)}
                                                                                                </span>
                                                                                                <span style={{ fontWeight: '700' }}>
                                                                                                    $ {(() => {
                                                                                                        const discountAmount = subItem.coupon.percentageOff 
                                                                                                            ? Math.round(subItem.price * (subItem.coupon.percentageOff / 100))
                                                                                                            : Math.abs(subItem.coupon.amountOff || 0);
                                                                                                        return AmountDivideByHundred(subItem.price - discountAmount);
                                                                                                    })()}
                                                                                                </span>
                                                                                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
                                                                                                    - Discount: ${(() => {
                                                                                                        const discountAmount = subItem.coupon.percentageOff 
                                                                                                            ? Math.round(subItem.price * (subItem.coupon.percentageOff / 100))
                                                                                                            : Math.abs(subItem.coupon.amountOff || 0);
                                                                                                        return AmountDivideByHundred(discountAmount);
                                                                                                    })()}
                                                                                                </div>
                                                                                            </>
                                                                                        ) : (
                                                                                            <span>$ {AmountDivideByHundred(subItem.price)}</span>
                                                                                        )}
                                                                                    </p>
                                                                                )}
                                                                            </div>

                                                                            {(() => {
                                                                                const customItemInUpdates = updates.find(
                                                                                    (u) => u.customItemGid === customItem.gid && u.productGid === eventPageProduct.gid && u.listedItem
                                                                                );
                                                                                const itemInUpdates = customItemInUpdates?.lineItemItems?.find(
                                                                                    (c) => c.itemGid === subItem.gid
                                                                                );

                                                                                return !itemInUpdates ? (
                                                                                    subItem.enableStock && subItem.onlineStock === 0 ? (
                                                                                        <img alt="" src={outOfStock} style={{ width: "64px", height: "64px" }} />
                                                                                    ) : (
                                                                                         <button
                                                                                            className="add-button"
                                                                                            style={{ background: eventDetails?.primaryColor || '#2563eb', color: '#fff', border: 'none' }}
                                                                                            disabled={subItem.enableStock && subItem.onlineStock === 0}
                                                                                            onClick={() => {
                                                                                                updateQuantity(customItem, subItem, null, null, 1, 0, undefined, eventPageProduct.gid);
                                                                                                if (subItem.modifierGroups?.length > 0) setActiveItemModifier(subItem.gid);
                                                                                            }}
                                                                                        >
                                                                                            Add
                                                                                        </button>
                                                                                    )
                                                                                ) : (
                                                                                    <div
                                                                                        className="figma-quantity-selector"
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            flexDirection: "row",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "space-between",
                                                                                            backgroundColor: "#FFFFFF",
                                                                                            borderRadius: "5px",
                                                                                            overflow: "hidden",
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            className="increase-decrease-button"
                                                                                            style={{ padding: "7px 14px", borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                                            onClick={() => {
                                                                                                updateQuantity(customItem, subItem, null, null, -1, 0, undefined, eventPageProduct.gid);
                                                                                                if (itemInUpdates?.quantity === 1 && activeItemModifier === subItem.gid) setActiveItemModifier(null);
                                                                                            }}
                                                                                        >
                                                                                            –
                                                                                        </button>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="input-item"
                                                                                            value={itemInUpdates?.quantity || 0}
                                                                                        />
                                                                                        {!(subItem.enableStock && itemInUpdates?.quantity * customItemInUpdates.quantity >= subItem.onlineStock) && (
                                                                                            <button
                                                                                                className="increase-decrease-button"
                                                                                                style={{ padding: "7px 14px", borderColor: eventDetails?.primaryColor || '#2563eb', color: '#fff', background: eventDetails?.primaryColor || '#2563eb' }}
                                                                                                onClick={() => {
                                                                                                    updateQuantity(customItem, subItem, null, null, 1, 0, undefined, eventPageProduct.gid);
                                                                                                    if (subItem.modifierGroups?.length > 0) setActiveItemModifier(subItem.gid);
                                                                                                }}
                                                                                            >
                                                                                                +
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })()}
                                                                        </div>

                                                                        {subItem.modifierGroups?.length > 0 && (
                                                                            <div style={{ position: "relative", margin: "5px 0 0", padding: "5px" }}>
                                                                                <button
                                                                                    onClick={() => toggleItemModifier(subItem.gid)}
                                                                                    disabled={subItem.enableStock && subItem.onlineStock === 0}
                                                                                    className="drop-down-menu"
                                                                                    style={{
                                                                                        background: `${eventDetails?.primaryColor || '#2563eb'}0a`,
                                                                                        borderColor: `${eventDetails?.primaryColor || '#2563eb'}30`,
                                                                                        color: eventDetails?.primaryColor || '#2563eb'
                                                                                    }}
                                                                                >
                                                                                    Add Modifications &#9660;
                                                                                </button>

                                                                                {activeItemModifier === subItem.gid && (
                                                                                    <div style={{ marginTop: "10px", marginLeft: mobileView ? "10px" : "20px" }}>
                                                                                        {subItem.modifierGroups.map((modifierGroup) => (
                                                                                            <div key={modifierGroup.gid} style={{ marginBottom: "5px" }}>
                                                                                                <h4
                                                                                                    className="additional-info mb-2"
                                                                                                    style={{ fontStyle: "normal", color: "#000000" }}
                                                                                                >
                                                                                                    {modifierGroup.name}{" "}
                                                                                                    {modifierGroup?.minRequired || modifierGroup?.maxAllowed
                                                                                                        ? `(${modifierGroup.minRequired ? "choose " + modifierGroup.minRequired : ""} ${modifierGroup.maxAllowed ? "max " + modifierGroup.maxAllowed : ""
                                                                                                        })`
                                                                                                        : ""}
                                                                                                </h4>

                                                                                                {modifierGroup?.modifiers.map((mod, modIndex) => {
                                                                                                    const customItemInUpdates = updates.find(
                                                                                                        (u) => u.customItemGid === customItem.gid && u.listedItem
                                                                                                    );
                                                                                                    const itemInUpdates = customItemInUpdates?.lineItemItems?.find(
                                                                                                        (u) => u.itemGid === subItem.gid
                                                                                                    );
                                                                                                    const modifiersInGroup = itemInUpdates?.lineItemModifiers.filter((lineItemModifier) =>
                                                                                                        modifierGroup.modifiers.some((modifier) => lineItemModifier.modifierGid === modifier.gid)
                                                                                                    ) || [];
                                                                                                    const modifierQuantityTotal = modifiersInGroup.reduce(
                                                                                                        (sum, lineItemModifier) => sum + (lineItemModifier.quantity || 0),
                                                                                                        0
                                                                                                    );
                                                                                                    const modifierInItem = itemInUpdates?.lineItemModifiers.find(
                                                                                                        (m) => m.modifierGid === mod.gid
                                                                                                    );
                                                                                                    const disableModifier =
                                                                                                        !mod.available ||
                                                                                                        (mod?.maxStackableQuantity && modifierInItem?.quantity >= mod.maxStackableQuantity) ||
                                                                                                        (modifierGroup?.maxAllowed && modifierQuantityTotal >= modifierGroup.maxAllowed);

                                                                                                    return (
                                                                                                        <div
                                                                                                            key={mod.gid}
                                                                                                            className="d-flex align-items-center justify-content-between"
                                                                                                            style={{
                                                                                                                paddingTop: "12px",
                                                                                                                paddingBottom: "12px",
                                                                                                                borderTop: modIndex === 0 ? "none" : "1px solid #f1f5f9",
                                                                                                            }}
                                                                                                        >
                                                                                                            <div>
                                                                                                                <p>{mod.name}</p>
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        margin: "5px 0 0",
                                                                                                                        color: "#555",
                                                                                                                        padding: "5px",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    $ {mod.price ? AmountDivideByHundred(mod.price) : "0.00"}
                                                                                                                </p>
                                                                                                            </div>

                                                                                                            {modifierInItem ? (
                                                                                                                <div
                                                                                                                    className="figma-quantity-selector"
                                                                                                                    style={{
                                                                                                                        display: "flex",
                                                                                                                        flexDirection: "row",
                                                                                                                        alignItems: "center",
                                                                                                                        justifyContent: "space-between",
                                                                                                                        backgroundColor: "#FFFFFF",
                                                                                                                        borderRadius: "5px",
                                                                                                                        overflow: "hidden",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <button
                                                                                                                        className="increase-decrease-button"
                                                                                                                        style={{ padding: "6px 12px", borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                                                                        onClick={() =>
                                                                                                                            updateQuantity(
                                                                                                                                customItem,
                                                                                                                                subItem,
                                                                                                                                mod,
                                                                                                                                null,
                                                                                                                                -1,
                                                                                                                                0
                                                                                                                            )
                                                                                                                        }
                                                                                                                    >
                                                                                                                        –
                                                                                                                    </button>
                                                                                                                    <input
                                                                                                                        type="text"
                                                                                                                        className="input-item"
                                                                                                                        value={
                                                                                                                            modifierInItem?.quantity || 0
                                                                                                                        }
                                                                                                                    />
                                                                                                                    {!disableModifier && (
                                                                                                                        <button
                                                                                                                            className="increase-decrease-button"
                                                                                                                            style={{ padding: "6px 12px", borderColor: eventDetails?.primaryColor || '#2563eb', color: '#fff', background: eventDetails?.primaryColor || '#2563eb' }}
                                                                                                                            onClick={() =>
                                                                                                                                updateQuantity(
                                                                                                                                    customItem,
                                                                                                                                    subItem,
                                                                                                                                    mod,
                                                                                                                                    null,
                                                                                                                                    1,
                                                                                                                                    0
                                                                                                                                )
                                                                                                                            }
                                                                                                                            disabled={disableModifier}
                                                                                                                        >
                                                                                                                            +
                                                                                                                        </button>
                                                                                                                    )}
                                                                                                                </div>
                                                                                                            ) : (
                                                                                                                <button
                                                                                                                    className="add-button"
                                                                                                                    style={{
                                                                                                                        padding: "8px 16px",
                                                                                                                        background: !disableModifier ? (eventDetails?.primaryColor || '#2563eb') : 'rgba(0,0,0,0.12)',
                                                                                                                        color: '#fff',
                                                                                                                        border: 'none'
                                                                                                                    }}
                                                                                                                    disabled={disableModifier}
                                                                                                                    onClick={() =>
                                                                                                                        updateQuantity(customItem, subItem, mod, null, 1, 0, undefined, eventPageProduct.gid)
                                                                                                                    }
                                                                                                                >
                                                                                                                    Add
                                                                                                                </button>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                )}

                                                                                {subItem.modifierGroups?.map((modifierGroup) => {
                                                                                    const customItemInUpdates = updates.find(
                                                                                        (u) => u.customItemGid === customItem.gid && u.listedItem
                                                                                    );
                                                                                    const itemInUpdates = customItemInUpdates?.lineItemItems?.find(
                                                                                        (u) => u.itemGid === subItem.gid
                                                                                    );
                                                                                    const modifiersInGroup = itemInUpdates?.lineItemModifiers.filter(
                                                                                        (lineItemModifier) =>
                                                                                            modifierGroup.modifiers.some(
                                                                                                (modifier) =>
                                                                                                    lineItemModifier.modifierGid === modifier.gid
                                                                                            )
                                                                                    ) || [];
                                                                                    const modifierQuantityTotal = modifiersInGroup.reduce(
                                                                                        (sum, lineItemModifier) =>
                                                                                            sum + (lineItemModifier.quantity || 0),
                                                                                        0
                                                                                    );

                                                                                    let updateValidationError = [...validationErrors];
                                                                                    const validationErrorIndex = updateValidationError.findIndex(
                                                                                        (update) =>
                                                                                            update.uniqueGid ===
                                                                                            modifierGroup.gid + "&" + subItem.gid + "&" + customItem.gid &&
                                                                                            update.productGid === eventPageProduct.gid
                                                                                    );

                                                                                    if (modifierGroup.minRequired && itemInUpdates?.quantity > 0) {
                                                                                        if (modifierQuantityTotal < modifierGroup.minRequired) {
                                                                                            if (validationErrorIndex === -1) {
                                                                                                updateValidationError.push({
                                                                                                    uniqueGid:
                                                                                                        modifierGroup.gid + "&" + subItem.gid + "&" + customItem.gid,
                                                                                                    itemGid: subItem.gid,
                                                                                                    customItemGid: customItem.gid,
                                                                                                    productGid: eventPageProduct.gid,
                                                                                                    errorMessage: `Add Modification -> "${modifierGroup.name}" : for Item -> "${subItem.displayName}"`,
                                                                                                });
                                                                                                setValidationErrors(updateValidationError);
                                                                                            }
                                                                                        } else if (validationErrorIndex !== -1) {
                                                                                            updateValidationError = updateValidationError.filter(
                                                                                                (_, index) => index !== validationErrorIndex
                                                                                            );
                                                                                            setValidationErrors(updateValidationError);
                                                                                        }
                                                                                    } else if (validationErrorIndex !== -1) {
                                                                                        updateValidationError = updateValidationError.filter(
                                                                                            (_, index) => index !== validationErrorIndex
                                                                                        );
                                                                                        setValidationErrors(updateValidationError);
                                                                                    }
                                                                                    return null;
                                                                                })}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Duplicated custom items */}
                                            {
                                                updates
                                                    .filter((lineItem) => lineItem.customItemGid === customItem.gid && !lineItem.listedItem)
                                                    .map((lineItem, lineIndex) => (
                                                        <div
                                                            key={lineIndex}
                                                            className="figma-line-item-card"
                                                            style={{ marginTop: '16px' }}
                                                        >
                                                            <div className="figma-line-item-header">
                                                                <div>
                                                                    <h3 style={{ margin: "10px 0 0", fontSize: "18px", padding: "5px" }}>
                                                                        {lineItem.name}
                                                                    </h3>
                                                                    {lineItem.seats?.length > 0 && (
                                                                        <p className="additional-info">Seats: [{lineItem.seats.join(", ")}]</p>
                                                                    )}
                                                                    {lineItem.lineItemDiscounts?.length > 0 && Number(orderDiscount) === 0 ? (
                                                                        <>
                                                                            <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '13px', marginRight: '8px' }}>
                                                                                $ {lineItem.price ? AmountDivideByHundred(lineItem.price) : "0.00"}
                                                                            </span>
                                                                            <span style={{ fontWeight: '700' }}>
                                                                                $ {(() => {
                                                                                    const disc = lineItem.lineItemDiscounts[0];
                                                                                    const discountAmount = disc.percentageOff 
                                                                                        ? Math.round(lineItem.price * (disc.percentageOff / 100))
                                                                                        : Math.abs(disc.amountOff || 0);
                                                                                    return AmountDivideByHundred(lineItem.price - discountAmount);
                                                                                })()}
                                                                            </span>
                                                                            <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '4px' }}>
                                                                                - Discount: ${(() => {
                                                                                    const disc = lineItem.lineItemDiscounts[0];
                                                                                    const discountAmount = disc.percentageOff 
                                                                                        ? Math.round(lineItem.price * (disc.percentageOff / 100))
                                                                                        : Math.abs(disc.amountOff || 0);
                                                                                    return AmountDivideByHundred(discountAmount);
                                                                                })()}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <span>$ {lineItem.price ? AmountDivideByHundred(lineItem.price) : "0.00"}</span>
                                                                    )}
                                                                </div>

                                                                    <div
                                                                        className="figma-quantity-selector"
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                            backgroundColor: "#FFFFFF",
                                                                            borderRadius: "5px",
                                                                            overflow: "hidden",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className="increase-decrease-button"
                                                                            style={{ borderColor: eventDetails?.primaryColor || '#2563eb', color: eventDetails?.primaryColor || '#2563eb', background: '#fff' }}
                                                                            onClick={() => updateQuantity(customItem, null, null, null, -1, 0, lineItem.duplicateIndex, eventPageProduct.gid)}
                                                                        >
                                                                            –
                                                                        </button>
                                                                        <input
                                                                            type="text"
                                                                            className="input-item"
                                                                            value={lineItem?.quantity || 0}
                                                                        />
                                                                        <button
                                                                            className="increase-decrease-button"
                                                                            style={{
                                                                                borderColor: eventDetails?.primaryColor || '#2563eb',
                                                                                color: '#fff',
                                                                                background: eventDetails?.primaryColor || '#2563eb',
                                                                                opacity: ((customItem?.enableStock && (
                                                                                    (customItem.stockQuantity !== undefined && lineItem.quantity >= customItem.stockQuantity) ||
                                                                                    (customItem.onlineStock !== undefined && lineItem.quantity >= customItem.onlineStock)
                                                                                )) || (customItem?.maxQuantity && lineItem.quantity >= customItem.maxQuantity)) ? 0.5 : 1,
                                                                                cursor: ((customItem?.enableStock && (
                                                                                    (customItem.stockQuantity !== undefined && lineItem.quantity >= customItem.stockQuantity) ||
                                                                                    (customItem.onlineStock !== undefined && lineItem.quantity >= customItem.onlineStock)
                                                                                )) || (customItem?.maxQuantity && lineItem.quantity >= customItem.maxQuantity)) ? 'not-allowed' : 'pointer'
                                                                            }}
                                                                            disabled={(customItem?.enableStock && (
                                                                                (customItem.stockQuantity !== undefined && lineItem.quantity >= customItem.stockQuantity) ||
                                                                                (customItem.onlineStock !== undefined && lineItem.quantity >= customItem.onlineStock)
                                                                            )) || (customItem?.maxQuantity && lineItem.quantity >= customItem.maxQuantity)}
                                                                            onClick={() => updateQuantity(customItem, null, null, null, 1, 0, lineItem.duplicateIndex, eventPageProduct.gid)}
                                                                        >
                                                                            +
                                                                        </button>
                                                                    </div>
                                                            </div>

                                                            {lineItem.lineItemModifiers?.length > 0 && (
                                                                <div style={{ padding: "5px" }}>
                                                                    <p className="additional-info">Modifiers:</p>
                                                                    {lineItem.lineItemModifiers.map((m, idx) => (
                                                                        <p key={idx} style={{ margin: "7.5px 20px", fontSize: "14px", color: "#555" }}>
                                                                            {m.name} (${m.price ? AmountDivideByHundred(m.price) : "0.00"} x {m.quantity})
                                                                        </p>
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {lineItem.lineItemItems?.length > 0 && (
                                                                <div style={{ padding: "5px" }}>
                                                                    <p className="additional-info">Items:</p>
                                                                    {lineItem.lineItemItems.map((lii, idx) => (
                                                                        <div key={idx}>
                                                                            <p style={{ margin: "0 20px", fontSize: "14px", color: "#555" }}>
                                                                                {lii.name} (
                                                                                {lii.lineItemModifiers?.length > 0
                                                                                    ? `($${lii.price ? AmountDivideByHundred(lii.price) : "0.00"} + (M - $${AmountDivideByHundred(
                                                                                        lii.lineItemModifiers.reduce((s, m) => s + m.quantity * m.price, 0)
                                                                                    )}))`
                                                                                    : `$${lii.price ? AmountDivideByHundred(lii.price) : "0.00"}`}{" "}
                                                                                x {lii.quantity})
                                                                                      {lii.lineItemDiscounts?.length > 0 && Number(orderDiscount) === 0 ? (
                                                                                          <div style={{ marginTop: '4px' }}>
                                                                                              <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '12px', marginRight: '6px' }}>
                                                                                                  $ {lii.price ? AmountDivideByHundred(lii.price) : "0.00"}
                                                                                              </span>
                                                                                              <span style={{ fontWeight: '600', fontSize: '13px' }}>
                                                                                                  $ {(() => {
                                                                                                      const disc = lii.lineItemDiscounts[0];
                                                                                                      const discountAmount = disc.percentageOff 
                                                                                                          ? Math.round(lii.price * (disc.percentageOff / 100))
                                                                                                          : Math.abs(disc.amountOff || 0);
                                                                                                      return AmountDivideByHundred(lii.price - discountAmount);
                                                                                                  })()}
                                                                                              </span>
                                                                                              <span style={{ fontSize: '11px', color: '#ef4444', marginLeft: '8px' }}>
                                                                                                  (-${(() => {
                                                                                                      const disc = lii.lineItemDiscounts[0];
                                                                                                      const discountAmount = disc.percentageOff 
                                                                                                          ? Math.round(lii.price * (disc.percentageOff / 100))
                                                                                                          : Math.abs(disc.amountOff || 0);
                                                                                                      return AmountDivideByHundred(discountAmount);
                                                                                                  })()})
                                                                                              </span>
                                                                                          </div>
                                                                                      ) : null}
                                                                            </p>

                                                                            {lii.lineItemModifiers?.length > 0 && (
                                                                                <>
                                                                                    <p className="additional-info" style={{ margin: "0 20px", padding: "5px" }}>
                                                                                        Modifiers(M):
                                                                                    </p>
                                                                                    {lii.lineItemModifiers.map((m, mIdx) => (
                                                                                        <p
                                                                                            key={`${idx}-${mIdx}`}
                                                                                            style={{ margin: "0 40px", fontSize: "14px", color: "#555", padding: "5px" }}
                                                                                        >
                                                                                            {m.name} (${m.price ? AmountDivideByHundred(m.price) : "0.00"} x {m.quantity})
                                                                                        </p>
                                                                                    ))}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))
                                            }
                                        </React.Fragment>
                                    ))}
                            </div>
                        ))}
                </div>
            </div>

            {/* Sidebar Booking Summary */}
            <div className="figma-sidebar-summary" style={!hideHeader && !mobileView ? { marginTop: '64px' } : {}}>
                <h2 className="figma-summary-title">Booking Summary</h2>

                {updates.length > 0 && (
                    <div style={{ marginBottom: "24px" }}>
                        {/* <div className="figma-summary-section-title">
                            <span role="img" aria-label="ticket">
                                🎫
                            </span>{" "}
                            Tickets
                        </div> */}
                        {updates.map((lineItem, idx) => (
                            <div key={idx} style={{ marginBottom: "12px" }}>
                                {(() => {
                                        const nameParts = lineItem?.name ? String(lineItem.name).split(' - ') : [];
                                        const isPriceStr = (str) => typeof str === 'string' && /^\s*[\$€£₹]?\s*\d+([.,]\d+)?\s*(USD|EUR|GBP|INR|CAD|AUD)?\s*$/i.test(str.trim());
                                        const nonPriceParts = nameParts.filter(p => !isPriceStr(p));
                                        const categoryName = nonPriceParts.length > 1 ? nonPriceParts[0] : lineItem?.name;
                                        const ticketTypeName = nonPriceParts.length > 1 ? nonPriceParts.slice(1).join(' - ') : null;

                                        const disc = lineItem.lineItemDiscounts?.[0];
                                        const unitDiscountCents = disc
                                            ? (Number(disc.amountOff) !== 0
                                                ? Math.abs(Number(disc.amountOff))
                                                : Math.round(lineItem.price * (Number(disc.percentageOff) / 100)))
                                            : 0;
                                        const parentDiscountCents = unitDiscountCents * lineItem.quantity;
                                        const parentGrossPriceCents = lineItem.price * lineItem.quantity;
                                        const parentNetPriceCents = parentGrossPriceCents - parentDiscountCents;

                                        return (
                                            <div className="figma-summary-item" style={{ flexDirection: 'column', alignItems: 'stretch', marginBottom: "4px" }}>
                                                {/* Category Name + base amount (top row — always visible) */}
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '2px' }}>
                                                    <div style={{ fontWeight: "600", color: '#1e293b' }}>
                                                        {categoryName}
                                                    </div>
                                                    <div style={{
                                                        fontWeight: "600",
                                                        marginLeft: '12px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                    }}>
                                                        {(() => {
                                                            const showPriceCents = lineItem.customItemAmount != null
                                                                ? lineItem.customItemAmount
                                                                : (ticketTypeName ? parentGrossPriceCents : parentNetPriceCents);
                                                            return (
                                                                <>
                                                                    <div>
                                                                        {!ticketTypeName && parentDiscountCents >= 1 && (
                                                                            <span style={{
                                                                                textDecoration: 'line-through',
                                                                                color: '#94a3b8',
                                                                                fontSize: '13px',
                                                                                marginRight: '6px',
                                                                                fontWeight: 'normal',
                                                                            }}>
                                                                                ${(parentGrossPriceCents / 100).toFixed(2)}
                                                                            </span>
                                                                        )}
                                                                        {showPriceCents > 0 && (
                                                                        <span>
                                                                            ${(showPriceCents / 100).toFixed(2)}
                                                                        </span>
                                                                        )}
                                                                    </div>
                                                                    {!ticketTypeName && parentDiscountCents >= 1 && (
                                                                        <div style={{
                                                                            fontSize: "10px",
                                                                            color: "#ef4444",
                                                                            marginTop: "2px",
                                                                            fontWeight: 'normal',
                                                                        }}>
                                                                            - Discount: ${(parentDiscountCents / 100).toFixed(2)}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>

                                                {/* Ticket Type + its price (sub-row, only when type exists) */}
                                                {ticketTypeName && (
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                                        <div style={{ fontSize: "13px", color: "#475569", fontWeight: "500" }}>
                                                            {ticketTypeName}
                                                        </div>
                                                        <div style={{ textAlign: "right", marginLeft: '12px' }}>
                                                            {parentNetPriceCents > 0 && (
                                                            <div style={{ fontWeight: "600", fontSize: "13px" }}>
                                                                ${(parentNetPriceCents / 100).toFixed(2)}
                                                            </div>
                                                            )}
                                                            {parentDiscountCents >= 1 && (
                                                                <div style={{ fontSize: "10px", color: "#ef4444", marginTop: "2px" }}>
                                                                    - Discount: ${(parentDiscountCents / 100).toFixed(2)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Qty + Seats */}
                                                <div style={{ fontSize: "12px", color: "#64748b" }}>
                                                    Qty: {lineItem.quantity}
                                                    {lineItem.seats?.length > 0 && ` • Seats: ${lineItem.seats.join(", ")}`}
                                                </div>
                                            </div>
                                        );
                                    })()}

                                {/* Main Modifiers */}
                                {lineItem.lineItemModifiers?.length > 0 && (
                                    <div style={{ fontSize: "11px", color: "#64748b", paddingLeft: "8px", borderLeft: "1px solid #e2e8f0", marginLeft: "4px" }}>
                                        {lineItem.lineItemModifiers.map((m, mIdx) => (
                                            <div key={mIdx} style={{ display: "flex", justifyContent: "space-between" }}>
                                                <span>+ {m.name} x {m.quantity * lineItem.quantity}</span>
                                                {m.price > 0 && (
                                                <span>${AmountDivideByHundred(m.price * m.quantity * lineItem.quantity)}</span>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Nested Items (Options) and their Modifiers */}
                                {lineItem.lineItemItems?.length > 0 && (
                                    <div style={{ fontSize: "11px", color: "#64748b", paddingLeft: "8px", borderLeft: "1px solid #e2e8f0", marginLeft: "4px" }}>
                                        {lineItem.lineItemItems.map((lii, liiIdx) => (
                                            <div key={liiIdx} style={{ marginBottom: "4px" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
                                                    <span>• {lii.name} x {lii.quantity * lineItem.quantity}</span>
                                                    <div style={{ textAlign: 'right' }}>
                                                        {(() => {
                                                            const unitDiscount = lii.lineItemDiscounts?.length > 0
                                                                ? (Number(lii.lineItemDiscounts[0].amountOff) !== 0
                                                                    ? Math.abs(Number(lii.lineItemDiscounts[0].amountOff))
                                                                    : Math.round(lii.price * (Number(lii.lineItemDiscounts[0].percentageOff) / 100)))
                                                                : 0;
                                                            const liiDiscountCents = unitDiscount * lii.quantity * lineItem.quantity;
                                                            const itemTotal = (lii.price + (lii.lineItemModifiers?.reduce((s, m) => s + m.price * m.quantity, 0) || 0)) * lii.quantity * lineItem.quantity;
                                                            const finalPriceCents = itemTotal - liiDiscountCents;

                                                            return (
                                                                <>
                                                                    <div style={{ fontWeight: "600" }}>
                                                                        {liiDiscountCents >= 1 ? (
                                                                            <>
                                                                                <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '10px', marginRight: '4px' }}>
                                                                                    ${(itemTotal / 100).toFixed(2)}
                                                                                </span>
                                                                                {finalPriceCents > 0 && (
                                                                                <span>
                                                                                    ${(finalPriceCents / 100).toFixed(2)}
                                                                                </span>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                            {itemTotal > 0 && (
                                                                            <span>${(itemTotal / 100).toFixed(2)}</span>
                                                                            )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    {liiDiscountCents >= 1 && (
                                                                        <div style={{ fontSize: "9px", color: "#ef4444" }}>
                                                                            - Discount: ${(liiDiscountCents / 100).toFixed(2)}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            );
                                                        })()}
                                                    </div>
                                                </div>
                                                {lii.lineItemModifiers?.length > 0 && (
                                                    <div style={{ paddingLeft: "8px", opacity: 0.8 }}>
                                                        {lii.lineItemModifiers.map((m, mIdx) => (
                                                            <div key={mIdx} style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <span>&nbsp;&nbsp;+ {m.name} x {m.quantity}</span>
                                                                {m.price > 0 && (
                                                                <span>${AmountDivideByHundred(m.price * m.quantity)}</span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}


                            </div>
                        ))}
                    </div>
                )}

                {/* Promo Code */}
                {eventDetails?.acceptPromo !== false && (
                <div className="figma-sidebar-promo-section" style={{ marginBottom: '8px' }}>
                    <div className="figma-summary-section-title">
                        {/* <span role="img" aria-label="promo">
                            🏷️
                        </span>{" "} */}
                        Promo Code
                    </div>
                    <div className="figma-promo-input-group">
                        <input
                            type="text"
                            className="figma-promo-input"
                            placeholder="Enter code"
                            value={promoCodeValue}
                            onChange={(e) => setPromoCodeValue(e.target.value.toUpperCase())}
                        />
                        <button
                            className="figma-promo-apply-btn"
                            style={{ background: eventDetails?.primaryColor || '#2563eb', color: '#fff' }}
                            onClick={handleApplyPromo}
                        >
                            Apply
                        </button>
                    </div>
                    {message && (
                        <div
                            style={{
                                marginTop: "8px",
                                fontSize: "13px",
                                color: message === "Promo-Code applied" ? "#10b981" : "#ef4444",
                            }}
                        >
                            {message}
                        </div>
                    )}
                </div>
                )}

                {/* Tip Section */}
                {eventDetails?.acceptTip !== false && (
                <div className="figma-sidebar-tip-section">
                    <div className="figma-summary-section-title">
                        {
                            eventGids.includes(eventDetails?.gid) ? (
                                <>Do you wish to Donate?</>
                            ) : (
                                <>{eventDetails?.tipLabel || 'Add a Tip'}</>
                            )
                        }
                    </div>
                    <div className="figma-tip-grid">
                        <button
                            className={`figma-tip-btn ${!customTip && tip === 0 ? "active" : ""}`}
                            style={!customTip && tip === 0 ? { background: eventDetails?.primaryColor || '#2563eb', color: '#fff' } : {}}
                            onClick={() => {
                                setCustomTip(false);
                                setTip(0);
                                setTipType("AMOUNT");
                                setTipInputValue("");
                                calculateOrder(0, "AMOUNT", null, promoCode);
                            }}
                        >
                            {tip === 0 && !customTip && <span style={{ marginRight: '4px' }}>✓</span>}
                            {
                                (eventGids.includes(eventDetails?.gid) || eventDetails?.tipLabel?.toLowerCase().includes("donate") || eventDetails?.tipLabel?.toLowerCase().includes("donation")) ? (
                                    <>No</>
                                ) : (
                                    <>None</>
                                )
                            }
                        </button>

                        {eventDetails?.eventPageTips?.map((t) => (
                            <button
                                key={`${t.tip}-${t.tipType}`}
                                className={`figma-tip-btn ${!customTip && tip === Math.round(t.tip * 100) && tipType === t.tipType ? "active" : ""}`}
                                style={!customTip && tip === Math.round(t.tip * 100) && tipType === t.tipType ? { background: eventDetails?.primaryColor || '#2563eb', color: '#fff' } : {}}
                                onClick={() => {
                                    setCustomTip(false);
                                    setTip(Math.round(t.tip * 100));
                                    setTipType(t.tipType);
                                    setTipInputValue("");
                                    calculateOrder(Math.round(t.tip * 100), t.tipType, null, promoCode);
                                }}
                            >
                                {!customTip && tip === Math.round(t.tip * 100) && tipType === t.tipType && (
                                    <span style={{ marginRight: '4px' }}>✓</span>
                                )}
                                {t.tipType === "AMOUNT" ? `$${t.tip}` : `${t.tip}%`}
                            </button>
                        ))}

                        <button
                            className={`figma-tip-btn ${customTip ? "active" : ""}`}
                            style={customTip ? { background: eventDetails?.primaryColor || '#2563eb', color: '#fff' } : {}}
                            onClick={() => {
                                setCustomTip(true);
                                setTip("");
                                setTipType("AMOUNT");
                                setTipInputValue("");
                                calculateOrder(0, "AMOUNT", null, promoCode);
                            }}
                        >
                            {customTip && <span style={{ marginRight: '4px' }}>✓</span>}
                            Custom
                        </button>
                    </div>

                    {customTip && (
                        <div className="figma-custom-tip-input-group">
                            <input
                                className="figma-promo-input"
                                style={{ flex: "1" }}
                                value={tipInputValue}
                                placeholder="$ 0.00"
                                onChange={(e) => {
                                    const regex = /^\d*\.?\d*$/;
                                    if (regex.test(e.target.value) || e.target.value === "") {
                                        setTipInputValue(e.target.value);
                                    }
                                }}
                            />
                            <button
                                className="figma-promo-apply-btn"
                                style={{ background: eventDetails?.primaryColor || '#2563eb', color: '#fff' }}
                                onClick={() => {
                                    setTip(tipInputValue);
                                    setTipType("AMOUNT");
                                    calculateOrder(tipInputValue, "AMOUNT", true, promoCode);
                                }}
                            >
                                Add
                            </button>
                        </div>
                    )}
                </div>
                )}

                {/* Bill Details */}
                <div className="figma-summary-footer">
                    {/* <div className="figma-summary-item">
                        <span>Tickets Subtotal</span>
                        <span>${subtotal}</span>
                    </div> */}

                    <div className="figma-summary-item">
                        <span>Subtotal</span>
                        <span>${subtotal}</span>
                    </div>

                    {Number(orderDiscount) !== 0 && (
                        <div className="figma-summary-item" style={{ marginTop: '-8px', marginBottom: '8px' }}>
                            <span style={{ fontSize: '13px', color: '#ef4444' }}>Promo Discount</span>
                            <span style={{ color: "#ef4444", fontSize: '13px' }}>- ${orderDiscount}</span>
                        </div>
                    )}

                    {Number(serviceCharge) !== 0 && (
                        <div className="figma-summary-item">
                            <span>Service Fee</span>
                            <span>${serviceCharge}</span>
                        </div>
                    )}

                    {Number(taxes) !== 0 && (
                        <div className="figma-summary-item">
                            <span>Taxes</span>
                            <span>${taxes}</span>
                        </div>
                    )}

                    {tipAmount !== 0 && (
                        <div className="figma-summary-item">
                            <span>
                                {
                                    (eventGids.includes(eventDetails?.gid) || eventDetails?.tipLabel?.toLowerCase().includes("donate") || eventDetails?.tipLabel?.toLowerCase().includes("donation")) ? (
                                        <>Donation</>
                                    ) : eventDetails?.tipLabel ? <>{eventDetails?.tipLabel}</> : (
                                        <>Tip</>
                                    )
                                }
                            </span>
                            <span>${AmountDivideByHundred(tipAmount)}</span>
                        </div>
                    )}

                    <div className="figma-total-box figma-desktop-only" style={{ background: '#f8fafc', padding: '24px', borderRadius: '12px', marginTop: '16px', display: 'flex' }}>
                        <span className="figma-total-label" style={{ fontWeight: '500', color: '#475569' }}>Total Amount:</span>
                        <span className="figma-total-value" style={{ fontWeight: '600', fontSize: '28px' }}>${total}</span>
                    </div>

                    <button
                        className="figma-proceed-btn figma-desktop-only"
                        onClick={handleCheckout}
                        disabled={payNow || isCalculating}
                    >
                        {payNow ? "Processing..." : isCalculating ? "Calculating..." : "Proceed to Checkout"}
                    </button>
                </div>
            </div>

            {/* Mobile Sticky Checkout Footer */}
            <div className="figma-sticky-footer">
                <div className="figma-total-info">
                    <span className="figma-total-label">Total Amount</span>
                    <span className="figma-total-value">${total}</span>
                </div>
                <button
                    onClick={handleCheckout}
                    disabled={payNow || isCalculating}
                    style={{ background: '#000', color: '#fff' }}
                >
                    {payNow ? "Processing..." : isCalculating ? "Calculating..." : "Proceed to Checkout"}
                </button>
            </div>
            {/* Image Preview Modal */}
            {isImageModalOpen && (
                <div className="figma-image-modal-overlay" onClick={closeImageModal}>
                    <div className="figma-image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="figma-image-modal-close" onClick={closeImageModal}>
                            ×
                        </button>
                        <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', borderRadius: '12px' }}>
                            <img
                                src={modalImageSrc}
                                alt=""
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    filter: 'blur(30px) brightness(0.7)',
                                    transform: 'scale(1.1)',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                }}
                            />
                            <img
                                src={modalImageSrc}
                                alt="Event Banner Preview"
                                className="figma-image-modal-image"
                                style={{
                                    position: 'relative',
                                    zIndex: 1,
                                    maxWidth: '100%',
                                    maxHeight: '90vh',
                                    objectFit: 'contain',
                                    border: 'none',
                                    boxShadow: 'none'
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default ProductReview;